var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon, _polygon2, _polygon3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _polygon19, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _polygon20, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _polygon21, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _polygon22, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _polygon23, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _polygon24, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _polygon25, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _polygon26, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _polygon27, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _polygon28, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _polygon29, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _polygon30, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _polygon31, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _polygon32, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _polygon33, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _polygon34, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _polygon35, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _polygon36, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _polygon37, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _polygon38, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _polygon39, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _polygon40, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _polygon41, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _polygon42, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _polygon43, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _polygon44, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _polygon45, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _polygon46, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _polygon47, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _circle, _circle2, _path511, _polygon48, _path512, _polygon49, _path513, _polygon50, _path514, _polygon51, _path515, _path516, _path517, _path518, _rect2, _path519, _path520, _path521, _path522, _rect3, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebFigureMotiv2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 493.98 362.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.77,287l.05,16.37a.5.5,0,0,0,.29.41,1.6,1.6,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l0-16.37a.49.49,0,0,1-.3.41,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,320.77,287Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.34,285.79l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.94A4.45,4.45,0,0,1,320.34,285.79Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.1,279.36l0,16.37a.53.53,0,0,0,.29.42,1.63,1.63,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l-.05-16.37a.52.52,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.53.53,0,0,1,307.1,279.36Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.67,278.12l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.47,4.47,0,0,1,306.67,278.12Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.75,271.69l.05,16.37a.48.48,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.29-.42l-.05-16.37a.48.48,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,293.75,271.69Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.32,270.45l-1.63-.95a4.47,4.47,0,0,0-1.85,3.33l1.62.94A4.49,4.49,0,0,1,293.32,270.45Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.07,264l.06,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.48.48,0,0,0,.29-.41L282.09,264a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.54.54,0,0,1,280.07,264Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.65,262.78l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95A4.49,4.49,0,0,1,279.65,262.78Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.6,255.88l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l-.05-16.36a.52.52,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,266.6,255.88Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.17,254.63l-1.62-.94a4.5,4.5,0,0,0-1.87,3.32l1.63.95A4.54,4.54,0,0,1,266.17,254.63Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.93,248.21l0,16.37a.49.49,0,0,0,.3.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.42l-.06-16.37a.49.49,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,252.93,248.21Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.5,247l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,252.5,247Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.58,240.53l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.5.5,0,0,0,.29-.41l0-16.37a.51.51,0,0,1-.31.41,1.55,1.55,0,0,1-1.42,0A.5.5,0,0,1,239.58,240.53Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.15,239.29l-1.63-.94a4.49,4.49,0,0,0-1.86,3.32l1.63,1A4.49,4.49,0,0,1,239.15,239.29Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.5,299.84l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.51.51,0,0,0,.3-.41l-.05-16.37a.51.51,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.49.49,0,0,1,298.5,299.84Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.07,298.59l-1.63-.94a4.51,4.51,0,0,0-1.86,3.33l1.63.94A4.53,4.53,0,0,1,298.07,298.59Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.83,292.18l.05,16.36a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,284.83,292.18Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.4,290.93l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.94A4.46,4.46,0,0,1,284.4,290.93Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.47,284.5l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l0-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,271.47,284.5Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,283.25l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94A4.52,4.52,0,0,1,271,283.25Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.8,276.83l.05,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.38a.53.53,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,257.8,276.83Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.37,275.58l-1.62-.94a4.5,4.5,0,0,0-1.87,3.33l1.64.94A4.49,4.49,0,0,1,257.37,275.58Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.33,268.69l0,16.36a.51.51,0,0,0,.29.42,1.61,1.61,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l0-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,244.33,268.69Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.89,267.44l-1.62-.95a4.53,4.53,0,0,0-1.86,3.33l1.63.95A4.5,4.5,0,0,1,243.89,267.44Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.65,261l.06,16.37a.47.47,0,0,0,.29.4,1.55,1.55,0,0,0,1.42,0,.52.52,0,0,0,.3-.42L232.67,261a.52.52,0,0,1-.3.42,1.61,1.61,0,0,1-1.42,0A.52.52,0,0,1,230.65,261Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.22,259.77l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.5,4.5,0,0,1,230.22,259.77Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.3,253.34l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.48.48,0,0,0,.29-.41l0-16.37a.52.52,0,0,1-.3.42,1.61,1.61,0,0,1-1.42,0A.52.52,0,0,1,217.3,253.34Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.87,252.1l-1.62-.95a4.49,4.49,0,0,0-1.86,3.33l1.62,1A4.52,4.52,0,0,1,216.87,252.1Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.47,312.09l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.53.53,0,0,0,.3-.41l-.06-16.37a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,277.47,312.09Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277,310.84l-1.63-.94a4.47,4.47,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,277,310.84Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.8,304.42l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.48.48,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,263.8,304.42Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.37,303.18l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95A4.49,4.49,0,0,1,263.37,303.18Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.44,296.75l.05,16.37a.49.49,0,0,0,.3.41,1.61,1.61,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l0-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,250.44,296.75Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,295.5l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.52,4.52,0,0,1,250,295.5Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.77,289.08l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.38a.52.52,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,236.77,289.08Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.34,287.83l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94A4.49,4.49,0,0,1,236.34,287.83Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.3,280.94l0,16.36a.51.51,0,0,0,.29.42,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l-.05-16.37a.5.5,0,0,1-.29.41,1.51,1.51,0,0,1-1.43,0A.5.5,0,0,1,223.3,280.94Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.86,279.69l-1.62-.95a4.49,4.49,0,0,0-1.85,3.33L221,283A4.53,4.53,0,0,1,222.86,279.69Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.62,273.27l.06,16.37a.53.53,0,0,0,.29.41,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l-.05-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.55.55,0,0,1,209.62,273.27Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.2,272l-1.63-.95a4.53,4.53,0,0,0-1.86,3.34l1.63.94A4.48,4.48,0,0,1,209.2,272Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.27,265.59l.06,16.37a.49.49,0,0,0,.28.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.49.49,0,0,1,196.27,265.59Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.84,264.35l-1.62-1a4.53,4.53,0,0,0-1.86,3.33l1.63.95A4.48,4.48,0,0,1,195.84,264.35Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.66,326.06l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l-.05-16.37a.49.49,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,253.66,326.06Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.22,324.81l-1.62-.94a4.49,4.49,0,0,0-1.86,3.32l1.63.95A4.52,4.52,0,0,1,253.22,324.81Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240,318.39l.06,16.37a.49.49,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.51.51,0,0,0,.29-.41L242,318.38a.51.51,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.54.54,0,0,1,240,318.39Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.56,317.14l-1.63-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.53,4.53,0,0,1,239.56,317.14Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.63,310.72l.05,16.37a.49.49,0,0,0,.29.4,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l0-16.37a.54.54,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.53.53,0,0,1,226.63,310.72Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.2,309.47l-1.63-.94a4.51,4.51,0,0,0-1.85,3.32l1.63.95A4.47,4.47,0,0,1,226.2,309.47Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213,303.05l0,16.37a.51.51,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.52.52,0,0,0,.3-.42L215,303a.52.52,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.51.51,0,0,1,213,303.05Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.53,301.8l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,212.53,301.8Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.49,294.9l0,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,199.49,294.9Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.06,293.66l-1.64-1a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.46,4.46,0,0,1,199.06,293.66Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.81,287.23l.05,16.38a.49.49,0,0,0,.3.4,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l0-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,185.81,287.23Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.38,286l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.5,4.5,0,0,1,185.38,286Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.46,279.56l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.42l-.06-16.37a.46.46,0,0,1-.29.42,1.55,1.55,0,0,1-1.42,0A.49.49,0,0,1,172.46,279.56Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,278.31l-1.63-.94a4.5,4.5,0,0,0-1.85,3.33l1.62.94A4.56,4.56,0,0,1,172,278.31Z",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.23,220.49l.05,16.37a.53.53,0,0,0,.29.41,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l0-16.37a.52.52,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.5.5,0,0,1,165.23,220.49Z",
    fill: "#7c8e3d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58",
    transform: "translate(-5.83 -9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.8,219.24l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.95A4.49,4.49,0,0,1,164.8,219.24Z",
    fill: "#f2682c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 118.18,
    width: 64.77,
    height: 34.93,
    fill: "#ef5182"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.36,10.72,42.3,23.85l4.93-13.13h3.85V27.85h-3V22.21l.3-7.56-5.06,13.2H41.22l-5-13.18.29,7.54v5.64h-3V10.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.78,21.37A7.55,7.55,0,0,1,54.52,18a5.37,5.37,0,0,1,2.09-2.3,5.83,5.83,0,0,1,3.08-.81,5.54,5.54,0,0,1,4.18,1.66A6.53,6.53,0,0,1,65.61,21v.67A7.57,7.57,0,0,1,64.9,25a5.4,5.4,0,0,1-2.08,2.3,5.89,5.89,0,0,1-3.11.81A5.55,5.55,0,0,1,55.4,26.3a6.88,6.88,0,0,1-1.62-4.79Zm2.86.25a5.17,5.17,0,0,0,.81,3.08,2.66,2.66,0,0,0,2.26,1.11A2.63,2.63,0,0,0,62,24.68a5.73,5.73,0,0,0,.8-3.31,5,5,0,0,0-.83-3.06,2.65,2.65,0,0,0-2.25-1.13,2.6,2.6,0,0,0-2.22,1.12A5.52,5.52,0,0,0,56.64,21.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5,21.4a7.57,7.57,0,0,1,1.37-4.73,4.37,4.37,0,0,1,3.66-1.78A4.18,4.18,0,0,1,75.8,16.3V9.78h2.86V27.85H76.07l-.14-1.31a4.24,4.24,0,0,1-3.43,1.55,4.36,4.36,0,0,1-3.62-1.8A7.85,7.85,0,0,1,67.5,21.4Zm2.86.24a5.26,5.26,0,0,0,.75,3,2.41,2.41,0,0,0,2.12,1.09A2.71,2.71,0,0,0,75.8,24.2V18.76a2.67,2.67,0,0,0-2.54-1.53,2.47,2.47,0,0,0-2.15,1.1A5.92,5.92,0,0,0,70.36,21.64Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.24,28.09a5.9,5.9,0,0,1-4.4-1.71,6.19,6.19,0,0,1-1.69-4.56v-.35a7.66,7.66,0,0,1,.74-3.41A5.59,5.59,0,0,1,84,15.72a5.52,5.52,0,0,1,3-.83,5,5,0,0,1,4,1.66,7,7,0,0,1,1.42,4.69V22.4H84a3.81,3.81,0,0,0,1.06,2.49,3.16,3.16,0,0,0,2.32.92,3.86,3.86,0,0,0,3.2-1.59l1.54,1.47a5.16,5.16,0,0,1-2,1.77A6.4,6.4,0,0,1,87.24,28.09ZM86.9,17.18A2.43,2.43,0,0,0,85,18a4.25,4.25,0,0,0-.92,2.29h5.45v-.21a3.49,3.49,0,0,0-.77-2.17A2.37,2.37,0,0,0,86.9,17.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.61,27.85H94.75V9.78h2.86Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.19,21.37a7.42,7.42,0,0,1,.74-3.37A5.35,5.35,0,0,1,109,15.7a5.85,5.85,0,0,1,3.08-.81,5.56,5.56,0,0,1,4.19,1.66A6.48,6.48,0,0,1,118,21v.67A7.57,7.57,0,0,1,117.3,25a5.32,5.32,0,0,1-2.07,2.3,5.93,5.93,0,0,1-3.11.81,5.52,5.52,0,0,1-4.31-1.79,6.88,6.88,0,0,1-1.62-4.79Zm2.86.25a5.17,5.17,0,0,0,.81,3.08,2.83,2.83,0,0,0,4.51,0,5.65,5.65,0,0,0,.81-3.31,5.11,5.11,0,0,0-.83-3.06,2.68,2.68,0,0,0-2.26-1.13,2.61,2.61,0,0,0-2.22,1.12A5.53,5.53,0,0,0,109.05,21.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.45,27.85V17.24h-1.94V15.12h1.94V14a4.39,4.39,0,0,1,1.17-3.27,4.53,4.53,0,0,1,3.3-1.15,6.71,6.71,0,0,1,1.6.21L127.45,12a6,6,0,0,0-1.1-.09,1.83,1.83,0,0,0-2,2.1v1.13h2.59v2.12h-2.59V27.85Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.79,10.72V22.17A5.57,5.57,0,0,1,146,26.5a7.66,7.66,0,0,1-9.32,0A5.61,5.61,0,0,1,135,22.16V10.72h3V22.18a3.66,3.66,0,0,0,.87,2.63,3.44,3.44,0,0,0,2.57.9c2.29,0,3.44-1.2,3.44-3.62V10.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.83,24.4a1.31,1.31,0,0,0-.63-1.17,6.57,6.57,0,0,0-2.09-.7,11.31,11.31,0,0,1-2.44-.78,3.26,3.26,0,0,1-2.14-3A3.39,3.39,0,0,1,151.92,16a5.53,5.53,0,0,1,3.53-1.1A5.74,5.74,0,0,1,159.14,16a3.57,3.57,0,0,1,1.4,2.93h-2.85a1.75,1.75,0,0,0-.62-1.37,2.31,2.31,0,0,0-1.62-.55,2.55,2.55,0,0,0-1.54.44,1.37,1.37,0,0,0-.59,1.16,1.14,1.14,0,0,0,.55,1,7.53,7.53,0,0,0,2.24.74,10.79,10.79,0,0,1,2.64.88,3.7,3.7,0,0,1,1.42,1.23,3.14,3.14,0,0,1,.47,1.74A3.33,3.33,0,0,1,159.21,27a6,6,0,0,1-3.73,1.06,6.63,6.63,0,0,1-2.78-.56A4.64,4.64,0,0,1,150.79,26a3.72,3.72,0,0,1-.68-2.13h2.77a2,2,0,0,0,.77,1.56,2.93,2.93,0,0,0,1.87.55,2.87,2.87,0,0,0,1.72-.43A1.34,1.34,0,0,0,157.83,24.4Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.73,28.09a5.9,5.9,0,0,1-4.4-1.71,6.19,6.19,0,0,1-1.69-4.56v-.35a7.66,7.66,0,0,1,.73-3.41,5.61,5.61,0,0,1,2.07-2.34,5.51,5.51,0,0,1,3-.83,5,5,0,0,1,4,1.66,7,7,0,0,1,1.42,4.69V22.4h-8.32a3.86,3.86,0,0,0,1,2.49,3.18,3.18,0,0,0,2.33.92,3.88,3.88,0,0,0,3.2-1.59l1.54,1.47a5.16,5.16,0,0,1-2,1.77A6.4,6.4,0,0,1,168.73,28.09Zm-.34-10.91a2.41,2.41,0,0,0-1.9.83,4.25,4.25,0,0,0-.92,2.29H171v-.21a3.49,3.49,0,0,0-.77-2.17A2.4,2.4,0,0,0,168.39,17.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.72,17.74a6.26,6.26,0,0,0-1.16-.1,2.63,2.63,0,0,0-2.65,1.51v8.7h-2.86V15.12h2.73l.07,1.43a3.22,3.22,0,0,1,2.87-1.66,2.64,2.64,0,0,1,1,.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.39,23.87h-6.63l-1.39,4h-3.09l6.47-17.13h2.67l6.48,17.13h-3.11Zm-5.8-2.4h5l-2.48-7.11Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M316.5,10.72l4.94,13.13,4.93-13.13h3.85V27.85h-3V22.21l.3-7.56-5.06,13.2h-2.13l-5.05-13.18.29,7.54v5.64h-3V10.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.92,21.37a7.55,7.55,0,0,1,.74-3.37,5.37,5.37,0,0,1,2.09-2.3,5.83,5.83,0,0,1,3.08-.81A5.54,5.54,0,0,1,343,16.55a6.53,6.53,0,0,1,1.74,4.4v.67A7.44,7.44,0,0,1,344,25a5.32,5.32,0,0,1-2.07,2.3,5.89,5.89,0,0,1-3.11.81,5.55,5.55,0,0,1-4.31-1.79,6.88,6.88,0,0,1-1.62-4.79Zm2.86.25a5.17,5.17,0,0,0,.81,3.08,2.84,2.84,0,0,0,4.52,0,5.73,5.73,0,0,0,.8-3.31,5,5,0,0,0-.83-3.06,2.65,2.65,0,0,0-2.25-1.13,2.6,2.6,0,0,0-2.22,1.12A5.52,5.52,0,0,0,335.78,21.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M346.64,21.4A7.57,7.57,0,0,1,348,16.67a4.37,4.37,0,0,1,3.66-1.78,4.18,4.18,0,0,1,3.27,1.41V9.78h2.86V27.85h-2.59l-.14-1.31a4.24,4.24,0,0,1-3.43,1.55,4.35,4.35,0,0,1-3.62-1.8A7.85,7.85,0,0,1,346.64,21.4Zm2.86.24a5.26,5.26,0,0,0,.75,3,2.41,2.41,0,0,0,2.12,1.09,2.71,2.71,0,0,0,2.57-1.56V18.76a2.67,2.67,0,0,0-2.54-1.53,2.47,2.47,0,0,0-2.15,1.1A5.92,5.92,0,0,0,349.5,21.64Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M366.38,28.09a5.9,5.9,0,0,1-4.4-1.71,6.19,6.19,0,0,1-1.69-4.56v-.35a7.53,7.53,0,0,1,.74-3.41,5.59,5.59,0,0,1,2.06-2.34,5.51,5.51,0,0,1,3-.83,5,5,0,0,1,4,1.66,7,7,0,0,1,1.42,4.69V22.4h-8.32a3.81,3.81,0,0,0,1.06,2.49,3.14,3.14,0,0,0,2.32.92,3.86,3.86,0,0,0,3.2-1.59l1.54,1.47a5.16,5.16,0,0,1-2,1.77A6.4,6.4,0,0,1,366.38,28.09ZM366,17.18a2.41,2.41,0,0,0-1.9.83,4.25,4.25,0,0,0-.92,2.29h5.45v-.21a3.49,3.49,0,0,0-.77-2.17A2.4,2.4,0,0,0,366,17.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M376.75,27.85h-2.86V9.78h2.86Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M385.33,21.37a7.42,7.42,0,0,1,.74-3.37,5.35,5.35,0,0,1,2.08-2.3,5.83,5.83,0,0,1,3.08-.81,5.56,5.56,0,0,1,4.19,1.66,6.48,6.48,0,0,1,1.73,4.4v.67a7.57,7.57,0,0,1-.72,3.36,5.32,5.32,0,0,1-2.07,2.3,5.93,5.93,0,0,1-3.11.81,5.55,5.55,0,0,1-4.32-1.79,6.92,6.92,0,0,1-1.61-4.79Zm2.86.25A5.17,5.17,0,0,0,389,24.7a2.83,2.83,0,0,0,4.51,0,5.65,5.65,0,0,0,.81-3.31,5.11,5.11,0,0,0-.83-3.06,2.68,2.68,0,0,0-2.26-1.13A2.61,2.61,0,0,0,389,18.3,5.53,5.53,0,0,0,388.19,21.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M400.59,27.85V17.24h-1.94V15.12h1.94V14a4.39,4.39,0,0,1,1.17-3.27,4.53,4.53,0,0,1,3.3-1.15,6.71,6.71,0,0,1,1.6.21L406.59,12a6,6,0,0,0-1.1-.09,1.83,1.83,0,0,0-2,2.1v1.13H406v2.12h-2.58V27.85Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M426.93,10.72V22.17a5.57,5.57,0,0,1-1.75,4.33,7.66,7.66,0,0,1-9.32,0,5.61,5.61,0,0,1-1.73-4.36V10.72h3V22.18a3.66,3.66,0,0,0,.87,2.63,3.42,3.42,0,0,0,2.57.9c2.29,0,3.43-1.2,3.43-3.62V10.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M437,24.4a1.31,1.31,0,0,0-.63-1.17,6.57,6.57,0,0,0-2.09-.7,11.31,11.31,0,0,1-2.44-.78,3.24,3.24,0,0,1-2.14-3A3.39,3.39,0,0,1,431.06,16a5.51,5.51,0,0,1,3.53-1.1A5.74,5.74,0,0,1,438.28,16a3.6,3.6,0,0,1,1.4,2.93h-2.86a1.74,1.74,0,0,0-.61-1.37,2.31,2.31,0,0,0-1.62-.55,2.55,2.55,0,0,0-1.54.44,1.37,1.37,0,0,0-.59,1.16,1.14,1.14,0,0,0,.55,1,7.53,7.53,0,0,0,2.24.74,10.79,10.79,0,0,1,2.64.88,3.7,3.7,0,0,1,1.42,1.23,3.14,3.14,0,0,1,.47,1.74A3.33,3.33,0,0,1,438.35,27a6.07,6.07,0,0,1-3.73,1.06,6.63,6.63,0,0,1-2.78-.56A4.58,4.58,0,0,1,429.93,26a3.72,3.72,0,0,1-.68-2.13H432a2,2,0,0,0,.77,1.56,2.93,2.93,0,0,0,1.87.55,2.89,2.89,0,0,0,1.72-.43A1.34,1.34,0,0,0,437,24.4Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M447.87,28.09a5.9,5.9,0,0,1-4.4-1.71,6.19,6.19,0,0,1-1.69-4.56v-.35a7.66,7.66,0,0,1,.73-3.41,5.61,5.61,0,0,1,2.07-2.34,5.48,5.48,0,0,1,3-.83,5,5,0,0,1,4,1.66A7,7,0,0,1,453,21.24V22.4h-8.32a3.86,3.86,0,0,0,1,2.49,3.18,3.18,0,0,0,2.33.92,3.88,3.88,0,0,0,3.2-1.59l1.54,1.47a5.16,5.16,0,0,1-2,1.77A6.4,6.4,0,0,1,447.87,28.09Zm-.34-10.91a2.41,2.41,0,0,0-1.9.83,4.25,4.25,0,0,0-.92,2.29h5.44v-.21a3.43,3.43,0,0,0-.76-2.17A2.4,2.4,0,0,0,447.53,17.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M461.86,17.74a6.34,6.34,0,0,0-1.16-.1,2.62,2.62,0,0,0-2.65,1.51v8.7h-2.86V15.12h2.73l.07,1.43a3.22,3.22,0,0,1,2.87-1.66,2.64,2.64,0,0,1,1,.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M469.94,27.85V10.72h5.88a7.14,7.14,0,0,1,4.42,1.17,4.11,4.11,0,0,1,1.52,3.47,3.68,3.68,0,0,1-.64,2.12,4.07,4.07,0,0,1-1.86,1.46,3.79,3.79,0,0,1,2.15,1.41,4.12,4.12,0,0,1,.76,2.5,4.57,4.57,0,0,1-1.55,3.71,6.74,6.74,0,0,1-4.43,1.29Zm3-9.91h2.92a3.36,3.36,0,0,0,2.17-.63,2.17,2.17,0,0,0,.78-1.79,2.19,2.19,0,0,0-.72-1.83,3.61,3.61,0,0,0-2.25-.57h-2.9Zm0,2.18v5.36h3.31a3.18,3.18,0,0,0,2.19-.7,2.44,2.44,0,0,0,.78-1.93,2.45,2.45,0,0,0-2.73-2.73Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#231f20"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "322.54 204.97 322.63 215.81 353.04 233.48 352.94 222.64 322.54 204.97",
    fill: "#461f1d",
    fillRule: "evenodd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.94 222.64 353.04 233.48 383.63 215.82 383.53 204.97 352.94 222.64",
    fill: "#211010",
    fillRule: "evenodd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.54 204.97 352.94 222.64 383.53 204.97 353.13 187.31 322.54 204.97",
    fill: "#53221f",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M358.64,202.92c.24-7.91.79-9.25,7.92-9.72C366,199.13,361.21,196.89,358.64,202.92Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M358.74,202.86a31.58,31.58,0,0,0,1.45-8.56c.05-2.56-.61-5.76-.08-8.06-1.11,1.22-.65,6-.76,8a71.72,71.72,0,0,1-1.22,8.52Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M364.27,213.93c.24-7.9.79-9.24,7.92-9.71C371.6,210.15,366.85,207.91,364.27,213.93Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M364.37,213.87a31,31,0,0,0,1.44-8.55c.06-2.57-.59-5.76-.07-8.07-1.11,1.23-.65,6-.76,8a75.69,75.69,0,0,1-1.21,8.52Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M352.53,218.92c.24-7.91.79-9.25,7.92-9.71C359.86,215.14,355.1,212.9,352.53,218.92Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M352.63,218.86a31,31,0,0,0,1.44-8.55c.06-2.57-.6-5.76-.07-8.07-1.11,1.22-.65,6-.76,8a74.3,74.3,0,0,1-1.22,8.53Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M340.06,218.2c.24-7.91.8-9.25,7.93-9.72C347.4,214.41,342.64,212.17,340.06,218.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M340.16,218.13a31.46,31.46,0,0,0,1.45-8.55c.06-2.57-.6-5.76-.08-8.06-1.11,1.22-.65,6-.75,8a76.21,76.21,0,0,1-1.22,8.52Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M359.28,227c.24-7.91.79-9.25,7.93-9.71C366.62,223.18,361.86,220.94,359.28,227Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M359.38,226.9a31.12,31.12,0,0,0,1.45-8.55c.05-2.57-.6-5.76-.08-8.07-1.11,1.22-.64,6-.75,8a76.32,76.32,0,0,1-1.22,8.53Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M377,217.64c.24-7.92.8-9.26,7.93-9.72C384.31,213.85,379.55,211.61,377,217.64Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M377.08,217.57a31.36,31.36,0,0,0,1.44-8.55c.06-2.57-.6-5.76-.07-8.06-1.12,1.22-.65,6-.76,8a76.32,76.32,0,0,1-1.22,8.53Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M420.05,346.8l6.93,3.72c1.06,6.13,1.62,9.14-.21,11.23-2.59,2.94-7.92,2.24-10.87.46a4.68,4.68,0,0,0-1-.48c-1.4-.51-2.58-.59-4.18-1.26-5-2.11-11.91-6.19-13.76-11-1.14-3,1-6.15,5.07-5.33l10.13,2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#44bb8c",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M428,358.49a5,5,0,0,1-1.18,3.26c-2.59,2.93-7.92,2.24-10.87.46a4.68,4.68,0,0,0-1-.48c-1.4-.51-2.58-.59-4.18-1.26-5-2.11-11.91-6.19-13.76-11a4.27,4.27,0,0,1-.08-3c.86,4.7,9.91,10.4,18.35,13.27C420.76,361.61,426.74,362.11,428,358.49Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#113227",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M410.8,299.28c1.16,3,4.33,7,5.55,9.78l11.91,45.51c-1.21,5.37-18.9-2.3-20-9.43l-12.36-39.48C390.42,289.15,409,283.8,410.8,299.28Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#1e3b3d",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M402,355.83l7.34,2.81c1.83,5.95,2.78,8.86,1.22,11.16-2.2,3.24-7.57,3.23-10.72,1.84a5.53,5.53,0,0,0-1-.35c-1.45-.33-2.62-.26-4.29-.72-5.27-1.45-12.61-4.62-15.06-9.2-1.52-2.84.18-6.22,4.35-5.93l10.3.73Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#44bb8c",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M411.31,366.42a5,5,0,0,1-.76,3.38c-2.2,3.24-7.57,3.23-10.72,1.84a5.53,5.53,0,0,0-1-.35c-1.45-.33-2.62-.26-4.29-.72-5.27-1.45-12.61-4.62-15.06-9.2a4.29,4.29,0,0,1-.46-2.93c1.46,4.56,11.15,9.06,19.9,10.83C404.57,370.43,410.57,370.16,411.31,366.42Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#113227",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87,305.06c1.79,4.19,4.75,9.52,5.69,12.55l9.57,46c-1,3.42-10.75-.12-11.32-.38-5-2.27-9-6-8.66-8.38l-13-45.14C375.63,298,394.08,289.58,395.87,305.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#2f5153",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M424.82,246.06c3.88,13.82,6.21,18.82-4.77,37.74-3.78,6.52-7.58,14.07-11.68,19.67-6,8.18-13.16,2.06-10.95-9.93,4-13.4,7.17-28.7,12-41.74Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#1e3b3d",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M414.82,254.83c2.41,10.64,1.5,22.75-3.73,30.46-6,8.93-12.17,17.79-17,27.61-4.54,7.7-18.43,2.5-15.52-9,4.77-12.46,6.66-36.14,11.55-47Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#2f5153",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M350.73,227.27c-5.66-3.2-6.06-4.57-9-6.35-1.94-1.19-8.71-2.17-13.92-6-2.27-1.68,0,9.09.05,10,.65,2.05,2.51,3.69,8.16,7.44,1.91,1.27,2.89,2.12,5.17,2.37l2.8.29,3,1.27,3.41-8.49-.17-.11Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M404.19,194.58c2.73,6.09,7.35,13.69,11.41,20.38,6.38,8.29,8.87,10.22,13.22,8.43,3.74-1.7,4-4,2.58-7.75-3.83-10.12-7.72-22.36-13.23-31.29-3.69-6-8.56-9.7-13.7-7.93C397.52,178.82,402,189.71,404.19,194.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M404.19,194.58c2.73,6.09,7.35,13.69,11.41,20.38,3,3.62,14.46-2.65,11.63-10.66-2.62-7.06-5.51-14.19-9.06-20-3.69-6-8.56-9.7-13.7-7.93C397.52,178.82,402,189.71,404.19,194.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#b1ddce",
    fillRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M415.76,213.36l-21.35.25c-1.37,5-1.11,6.75-.64,11.68,2.91.41,25,1.5,33.9.3,4.07-.55,4.72-2.27,4.44-6.31C431.57,212,422.8,213.31,415.76,213.36Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M413.61,177.89a19.24,19.24,0,0,1,5.36,7.59c7.62,17.13,3.81,38.86,6.46,56.88a34.94,34.94,0,0,0,.84,5.32c.93,12.62-32.23,20.06-38.83,17.72-5.77-6.8-12.38-46.84-12.78-58.22-.21-6.19,1.29-10.41,5.2-15.55a39.6,39.6,0,0,1,7.94-7.73C393.76,179.51,406.5,172.42,413.61,177.89Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#c7e7dc",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M375.34,201.26c-1.95,10-1,21.65-2.44,32.64-1,9.37-3.12,14.11,4.77,15.75,4.21,1.12,5.55-.3,6.91-4.38l7.08-30.57c3-14.43-.94-16.76-6.17-18.44C380.53,194.67,376.07,197.52,375.34,201.26Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M375.18,201.26c-1.18,6.06-1.95,18.09-2.18,24.81,2.25,4.31,14.11,8,16.45,3.49l2.62-14.86c3-14.43-1.35-16.76-6.58-18.44C380.53,194.67,375.91,197.52,375.18,201.26Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#d5ece4",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M369.9,233.1l-22.41-7.67c-3.05,2.9-3.47,5-3.47,9.54,2.72,1.52,23.63,12.56,32.91,14.83,4.24,1,5.55-.41,6.83-4.52C385.18,240.59,383,237.36,369.9,233.1Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M347.42,225.69c-.84-1.77-1.39-3.79-2-5.37-.94-2.32-2.58-2.79-4.09-3.72-.94-.57-6.05-3.7-6.41-3.65-1.22,1.73.33,4.57,3.55,6.06l1.91,2.82Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M379.66,152.89c-3.9,3.24-3.13,6.55-1.21,15.84.26,5.74.44,11.79,3,14.23,1.84,1.76,5.63.51,7.42-.74,0,2.11.54,4.32.51,6.44,4.49,2.14,12.73.89,14.76-3.11-1.57-7.09-2.37-8.47-2.38-12,0-5.56,1.57-12.42-.14-17.8-.9-2.84-3-5-7.88-6.3A16,16,0,0,0,379.66,152.89Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M386.57,173.34c.78,2.71,1.06,4.9.15,6.06-.69.88-2.27,1.46-3.68-.47s-.93-3.47-4.23-5.1c0,.66.06,1.37.09,2,.76.84,2.15,2.24,2.07,3.22-.1,1.28-1.05.08-1.36-.28.35,4.29,2,9.05,2.77,9.16,2.51.38,7.69-6.31,7.72-7.7C390.15,177.93,388.21,175.46,386.57,173.34Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#e5e5e4",
    fillRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M378.12,161.69a9.75,9.75,0,0,1-2-7.36c1.42-5.84,9.52-8.48,16-8.12,7.14.41,11,3.48,12.62,8.27,1.9,5.6-.33,13.43-2.69,19.56-1.64,4.27-4,4.08-7.15,2.89a10.17,10.17,0,0,1-4.05-2.69c-3-3.3-2.9-5.23-7.08-8.33l-.41,2c-.43,2.16-1.33,1.83-1.8-.21-.36-1.55,0-1.87-.25-3.68C381.09,162.72,380.35,161.9,378.12,161.69Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#e5e5e4",
    fillRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M388.77,183.62c.15,1.62.64,3.45.62,5,2.9,3.08,13.39,1.27,14.76-3.11-.74-3.34-.65-6.83-1-8.45C401.42,181.86,392.45,185.57,388.77,183.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#d5ece4",
    fillRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M350.73,226.54c-.1-.86-2.78-2.12-3.31-1.61-3.4,1.13-4.68,6.7-2.92,10.47.59.64,3.3,2.79,3.95,1.92C347.42,235.34,347.24,228,350.73,226.54Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M346.06,228.15a2.21,2.21,0,0,0-2.3,1.92,2,2,0,0,0,1.43,2.52,2.2,2.2,0,0,0,2.3-1.93,2,2,0,0,0-1.43-2.51",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M350.73,226.54a1,1,0,0,0-.28-.49c-3.66,1.57-3.58,9-2.54,11.47a.57.57,0,0,0,.54-.2C347.42,235.34,347.24,228,350.73,226.54Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.59 288.03 243.74 342.56 149.29 288.03 243.13 233.5 337.59 288.03",
    fill: "#68442e"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.32 334.81 250.61 338.63 156.15 284.1 162.86 280.28 257.32 334.81",
    fill: "#905e3f"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.06 334.31 251.34 338.13 156.88 283.6 163.59 279.78 258.06 334.31",
    fill: "#432c1d"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.51 332.4 258.14 334.31 163.7 279.78 167.05 277.87 261.51 332.4",
    fill: "#2e1f15"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.74 342.56 243.74 351.32 149.28 296.79 149.29 288.03 243.74 342.56",
    fill: "#3b261b"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.59 288.03 337.58 296.79 243.74 351.32 243.74 342.56 337.59 288.03",
    fill: "#503424"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.61 320.8 274.89 324.61 180.44 270.08 187.15 266.26 281.61 320.8",
    fill: "#905e3f"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.33 320.3 275.62 324.12 181.17 269.58 187.88 265.77 282.33 320.3",
    fill: "#432c1d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.79 318.39 282.43 320.3 187.98 265.77 191.34 263.86 285.79 318.39",
    fill: "#2e1f15"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.28 308.53 295.56 312.35 201.11 257.82 207.82 254 302.28 308.53",
    fill: "#905e3f"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.01 308.03 296.3 311.85 201.85 257.32 208.56 253.5 303.01 308.03",
    fill: "#432c1d"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.47 306.12 303.11 308.03 208.65 253.5 212.01 251.59 306.47 306.12",
    fill: "#2e1f15"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.32 295.95 317.61 299.77 223.16 245.23 229.87 241.42 324.32 295.95",
    fill: "#905e3f"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.05 295.45 318.34 299.27 223.89 244.74 230.6 240.92 325.05 295.45",
    fill: "#432c1d"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "328.51 293.54 325.15 295.45 230.69 240.92 234.05 239.01 328.51 293.54",
    fill: "#2e1f15"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M320.77,287l.05,16.37a.5.5,0,0,0,.29.41,1.6,1.6,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l0-16.37a.49.49,0,0,1-.3.41,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,320.77,287Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M320.77,287l.05,16.37a.5.5,0,0,0,.29.41.51.51,0,0,0,.15.07l0-16.36-.16-.08a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M321.22,287.52l0,16.36a1.39,1.39,0,0,0,.35.09l-.05-16.37a1.21,1.21,0,0,1-.34-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M321.56,287.6l.05,16.37a1.6,1.6,0,0,0,.93-.15l0,0,0-16.37-.06,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M322.55,287.41l0,16.37a.57.57,0,0,0,.19-.19l0-16.37a.68.68,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74,287.22l0,16.37a.35.35,0,0,0,.06-.19l0-16.37a.45.45,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07,286.62c-.4.23-.4.6,0,.82a1.57,1.57,0,0,0,1.43,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,321.07,286.62Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M326.18,283.18l-1.62-.95a1.06,1.06,0,0,0-1.05.07l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.62.95a3.6,3.6,0,0,1,1.17-1.24l.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M323.8,284.45l-1.62-.95a1.05,1.05,0,0,0-1.05.06l-.06,0a3.48,3.48,0,0,0-1.15,1.22l1.62.95a3.6,3.6,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M318.46,289.13l-1.63-.94c-.14,2.5.48,4,1.47,4.57l1.62.95c-1-.58-1.6-2.08-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.66 279.58 311.04 278.63 311 278.65 312.63 279.6 312.66 279.58",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M321.45,285.69l-1.63-.94a1,1,0,0,0-1,.06l-.07,0,1.63,1,.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,285.79l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.94A4.45,4.45,0,0,1,320.34,285.79Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,285.79l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.94a4.45,4.45,0,0,1,1.85-3.32Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M320.34,285.79a4.45,4.45,0,0,0-1.85,3.32l0,0c-.24,4.39,1.84,5.68,4.16,4.34s3.79-4.29,4.12-8.73c.09-1.34-.63-2-1.6-1.5l-.07,0a3.6,3.6,0,0,0-1.17,1.24,1,1,0,0,0-1.14,0l-.06,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M307.1,279.36l0,16.37a.53.53,0,0,0,.29.42,1.63,1.63,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l-.05-16.37a.52.52,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.53.53,0,0,1,307.1,279.36Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M307.1,279.36l0,16.37a.53.53,0,0,0,.29.42l.15.07,0-16.38-.15-.06a.53.53,0,0,1-.29-.42Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M307.54,279.84l0,16.38a1.37,1.37,0,0,0,.35.08l-.05-16.37a1.06,1.06,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M307.89,279.93l.05,16.37a1.6,1.6,0,0,0,.93-.15l.05,0,0-16.37-.06,0a1.6,1.6,0,0,1-.93.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M308.88,279.74l0,16.37a.49.49,0,0,0,.19-.19l-.05-16.37a.64.64,0,0,1-.18.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M309.06,279.55l.05,16.37a.35.35,0,0,0,.06-.19l-.05-16.37a.35.35,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M307.4,279c-.39.23-.4.6,0,.83a1.63,1.63,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.55,1.55,0,0,0,307.4,279Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M312.51,275.51l-1.62-.94a1.05,1.05,0,0,0-1.05.06l-.06,0a3.47,3.47,0,0,0-1.17,1.23l1.62,1a3.6,3.6,0,0,1,1.17-1.24l.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M310.13,276.77l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.51,3.51,0,0,0-1.16,1.22l1.63.95a3.42,3.42,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M304.79,281.46l-1.63-.94c-.14,2.5.48,4,1.47,4.57l1.62,1c-1-.58-1.6-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "298.99 271.91 297.36 270.97 297.33 270.98 298.96 271.93 298.99 271.91",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M307.78,278l-1.63-.94a1,1,0,0,0-1,.06l-.07,0,1.63.95.06,0a1.08,1.08,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M306.67,278.12l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.47,4.47,0,0,1,306.67,278.12Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M306.67,278.12l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95a4.47,4.47,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M306.67,278.12a4.47,4.47,0,0,0-1.85,3.33h0c-.25,4.39,1.84,5.68,4.16,4.34s3.8-4.29,4.12-8.73c.09-1.34-.63-2-1.6-1.5l-.07,0a3.6,3.6,0,0,0-1.17,1.24,1,1,0,0,0-1.14,0l-.06,0a3.42,3.42,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M293.75,271.69l.05,16.37a.48.48,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.29-.42l-.05-16.37a.48.48,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,293.75,271.69Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M293.75,271.69l.05,16.37a.48.48,0,0,0,.29.41l.15.07-.05-16.37-.15-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M294.19,272.17l.05,16.37a1.89,1.89,0,0,0,.34.09l0-16.37a1.79,1.79,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M294.54,272.26l0,16.37a1.56,1.56,0,0,0,.94-.16l.05,0-.05-16.37,0,0a1.53,1.53,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M295.52,272.07l.05,16.37a.85.85,0,0,0,.19-.19l-.05-16.37a.85.85,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M295.71,271.88l.05,16.37a.46.46,0,0,0,.05-.2l-.05-16.37a.49.49,0,0,1-.05.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M294.05,271.27c-.4.24-.4.6,0,.83a1.57,1.57,0,0,0,1.43,0c.39-.23.39-.59,0-.83A1.61,1.61,0,0,0,294.05,271.27Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M299.16,267.84l-1.63-.95a1.06,1.06,0,0,0-1,.06l-.07,0a3.6,3.6,0,0,0-1.17,1.24l1.63.95a3.51,3.51,0,0,1,1.17-1.24l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M296.78,269.1l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.51,3.51,0,0,0-1.16,1.22l1.63.94a3.45,3.45,0,0,1,1.15-1.21l.06,0a1.08,1.08,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M291.43,273.79l-1.62-1c-.14,2.51.48,4,1.46,4.58l1.63.94c-1-.57-1.61-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.64 264.24 284.01 263.29 283.98 263.31 285.61 264.25 285.64 264.24",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M294.42,270.35l-1.62-1a1.08,1.08,0,0,0-1.05.06l-.06,0,1.63.95.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M293.32,270.45l-1.63-.95a4.47,4.47,0,0,0-1.85,3.33l1.62.94A4.49,4.49,0,0,1,293.32,270.45Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M293.32,270.45l-1.63-.95a4.47,4.47,0,0,0-1.85,3.33l1.62.94a4.49,4.49,0,0,1,1.86-3.32Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M293.32,270.45a4.49,4.49,0,0,0-1.86,3.32l0,0c-.24,4.39,1.85,5.68,4.17,4.34s3.79-4.29,4.11-8.73c.09-1.34-.62-2-1.6-1.5l-.06,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.45,3.45,0,0,0-1.15,1.21,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M280.07,264l.06,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.48.48,0,0,0,.29-.41L282.09,264a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.54.54,0,0,1,280.07,264Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M280.07,264l.06,16.37a.5.5,0,0,0,.29.41l.15.08-.05-16.38a.51.51,0,0,1-.15-.07.54.54,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M280.52,264.5l.05,16.38a1.87,1.87,0,0,0,.34.08l0-16.37a1.28,1.28,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M280.87,264.59l0,16.37a1.56,1.56,0,0,0,.94-.16l0,0,0-16.37-.05,0a1.54,1.54,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M281.85,264.4l0,16.37a.68.68,0,0,0,.19-.19l0-16.37a.68.68,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M282,264.21l0,16.37a.45.45,0,0,0,.05-.19L282.09,264a.45.45,0,0,1,0,.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M280.38,263.61c-.4.23-.4.6,0,.82a1.57,1.57,0,0,0,1.43,0,.43.43,0,0,0,0-.82A1.55,1.55,0,0,0,280.38,263.61Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M285.49,260.17l-1.63-.94a1,1,0,0,0-1,.06l-.07,0a3.49,3.49,0,0,0-1.16,1.24l1.62.95a3.51,3.51,0,0,1,1.17-1.24l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M283.1,261.43l-1.62-.94a1.05,1.05,0,0,0-1.05.06l-.05,0a3.53,3.53,0,0,0-1.17,1.22l1.64.95a3.48,3.48,0,0,1,1.15-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M277.76,266.12l-1.62-.94c-.14,2.5.47,4,1.47,4.57l1.62.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.96 256.57 270.34 255.62 270.31 255.64 271.94 256.58 271.96 256.57",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M280.75,262.68l-1.63-.94a1,1,0,0,0-1,.06l-.06,0,1.63.95.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M279.65,262.78l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95A4.49,4.49,0,0,1,279.65,262.78Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M279.65,262.78l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95a4.49,4.49,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M279.65,262.78a4.49,4.49,0,0,0-1.86,3.33h0c-.24,4.39,1.84,5.68,4.16,4.34s3.8-4.29,4.12-8.73c.09-1.34-.63-2-1.6-1.5l-.06,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.48,3.48,0,0,0-1.15,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M266.6,255.88l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.52.52,0,0,0,.3-.42l-.05-16.36a.52.52,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,266.6,255.88Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M266.6,255.88l0,16.37a.5.5,0,0,0,.29.41l.15.07,0-16.37-.15-.07a.51.51,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M267.05,256.36l0,16.37a1.37,1.37,0,0,0,.35.08l-.05-16.36a1.69,1.69,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M267.39,256.45l.05,16.36a1.61,1.61,0,0,0,.93-.15l.05,0-.05-16.37a.1.1,0,0,1-.05,0,1.59,1.59,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M268.37,256.25l.05,16.37a.55.55,0,0,0,.19-.18l-.05-16.38a.49.49,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M268.56,256.06l.05,16.38a.39.39,0,0,0,.06-.2l-.05-16.36a.35.35,0,0,1-.06.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M266.9,255.46a.44.44,0,0,0,0,.83,1.55,1.55,0,0,0,1.42,0,.44.44,0,0,0,0-.83A1.55,1.55,0,0,0,266.9,255.46Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M272,252l-1.62-.94a1.08,1.08,0,0,0-1.05.06l-.06,0a3.51,3.51,0,0,0-1.17,1.24l1.63.94a3.43,3.43,0,0,1,1.17-1.24l.06,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M269.63,253.29l-1.63-.95a1.06,1.06,0,0,0-1,.06s0,0-.06,0a3.59,3.59,0,0,0-1.16,1.22l1.63.95a3.51,3.51,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M264.29,258l-1.63-1c-.14,2.51.48,4,1.47,4.58l1.62.94c-1-.58-1.6-2.07-1.46-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.49 248.43 256.86 247.48 256.83 247.49 258.46 248.44 258.49 248.43",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M267.27,254.53l-1.62-.94a1.06,1.06,0,0,0-1,.06.09.09,0,0,0-.06,0l1.62.94.07,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M266.17,254.63l-1.62-.94a4.5,4.5,0,0,0-1.87,3.32l1.63.95A4.54,4.54,0,0,1,266.17,254.63Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M266.17,254.63l-1.62-.94a4.5,4.5,0,0,0-1.87,3.32l1.63.95a4.54,4.54,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M266.17,254.63a4.54,4.54,0,0,0-1.86,3.33l0,0c-.25,4.39,1.84,5.67,4.15,4.34s3.8-4.3,4.13-8.74c.09-1.34-.63-2-1.6-1.49l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M252.93,248.21l0,16.37a.49.49,0,0,0,.3.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.42l-.06-16.37a.49.49,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,252.93,248.21Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M252.93,248.21l0,16.37a.49.49,0,0,0,.3.41l.14.07,0-16.37-.15-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M253.37,248.69l0,16.37a2,2,0,0,0,.35.09l-.06-16.37a1.89,1.89,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M253.71,248.78l.06,16.37a1.54,1.54,0,0,0,.93-.16s0,0,.05,0l-.05-16.36,0,0a1.55,1.55,0,0,1-.94.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M254.7,248.59l.05,16.36a.49.49,0,0,0,.19-.19l-.05-16.37a.59.59,0,0,1-.19.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M254.89,248.39l.05,16.37a.33.33,0,0,0,.06-.19l-.06-16.37a.32.32,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M253.22,247.79a.44.44,0,0,0,0,.83,1.57,1.57,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.63,1.63,0,0,0,253.22,247.79Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M258.34,244.36l-1.63-1a1.06,1.06,0,0,0-1,.06l-.07,0a3.49,3.49,0,0,0-1.16,1.24l1.62.94a3.69,3.69,0,0,1,1.17-1.24l.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M256,245.62l-1.63-1a1.06,1.06,0,0,0-1,.06l-.06,0a3.56,3.56,0,0,0-1.16,1.21l1.63,1a3.51,3.51,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M250.61,250.31l-1.62-.95c-.14,2.5.48,4,1.47,4.57l1.63.95c-1-.57-1.61-2.07-1.48-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.82 240.75 243.19 239.81 243.16 239.82 244.79 240.77 244.82 240.75",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6,246.87l-1.62-1a1.08,1.08,0,0,0-1,.06l-.06,0,1.63.94.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5,247l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,252.5,247Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5,247l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,252.5,247Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5,247a4.53,4.53,0,0,0-1.86,3.33l0,0c-.24,4.39,1.85,5.68,4.16,4.34s3.8-4.3,4.13-8.74c.09-1.34-.63-2-1.6-1.49l-.07,0a3.69,3.69,0,0,0-1.17,1.24,1,1,0,0,0-1.14,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M239.58,240.53l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.5.5,0,0,0,.29-.41l0-16.37a.51.51,0,0,1-.31.41,1.55,1.55,0,0,1-1.42,0A.5.5,0,0,1,239.58,240.53Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M239.58,240.53l0,16.37a.5.5,0,0,0,.29.41l.15.08L240,241l-.15-.08a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M240,241l0,16.37a1.3,1.3,0,0,0,.34.08l0-16.37A1.28,1.28,0,0,1,240,241Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M240.37,241.1l0,16.37a1.56,1.56,0,0,0,.94-.16l.05,0-.05-16.37-.06,0a1.43,1.43,0,0,1-.92.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M241.35,240.91l.05,16.37a.68.68,0,0,0,.19-.19l-.05-16.37a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M241.54,240.72l.05,16.37a.41.41,0,0,0,0-.19l0-16.37a.35.35,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M239.88,240.12c-.4.23-.4.6,0,.82a1.55,1.55,0,0,0,1.42,0,.43.43,0,0,0,0-.82A1.55,1.55,0,0,0,239.88,240.12Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M245,236.68l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.71,3.71,0,0,0-1.18,1.24l1.63,1a3.51,3.51,0,0,1,1.17-1.24l.07,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M242.6,238,241,237a1.08,1.08,0,0,0-1,.06l-.05,0a3.5,3.5,0,0,0-1.16,1.22l1.63.95A3.48,3.48,0,0,1,241.5,238l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M237.27,242.63l-1.63-.94c-.14,2.5.47,4,1.46,4.57l1.63,1c-1-.58-1.61-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.46 233.08 229.84 232.14 229.81 232.15 231.44 233.1 231.46 233.08",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M240.25,239.2l-1.63-.95a1,1,0,0,0-1,.06l-.06,0,1.63.94.06,0a1,1,0,0,1,1-.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M239.15,239.29l-1.63-.94a4.49,4.49,0,0,0-1.86,3.32l1.63,1A4.49,4.49,0,0,1,239.15,239.29Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M239.15,239.29l-1.63-.94a4.49,4.49,0,0,0-1.86,3.32l1.63,1a4.49,4.49,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M239.15,239.29a4.49,4.49,0,0,0-1.86,3.33h0c-.25,4.39,1.83,5.68,4.15,4.35s3.8-4.3,4.13-8.74c.08-1.34-.64-2-1.6-1.49l-.07,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.48,3.48,0,0,0-1.15,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5,299.84l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.51.51,0,0,0,.3-.41l-.05-16.37a.51.51,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.49.49,0,0,1,298.5,299.84Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5,299.84l.05,16.37a.48.48,0,0,0,.29.41l.14.07,0-16.37-.15-.07a.49.49,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M298.94,300.32l0,16.37a2,2,0,0,0,.35.09l-.05-16.37a1.31,1.31,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M299.28,300.41l.05,16.37a1.59,1.59,0,0,0,.93-.16l.06,0-.05-16.37,0,0a1.56,1.56,0,0,1-.94.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M300.27,300.22l.05,16.37a.85.85,0,0,0,.19-.19L300.46,300a.68.68,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M300.46,300l.05,16.37a.36.36,0,0,0,.05-.19l-.05-16.37a.49.49,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M298.79,299.43a.43.43,0,0,0,0,.82,1.57,1.57,0,0,0,1.43,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,298.79,299.43Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M303.91,296l-1.63-.95a1,1,0,0,0-1,.07l-.07,0a3.51,3.51,0,0,0-1.17,1.24l1.63.94a3.39,3.39,0,0,1,1.17-1.23l.06,0a1.05,1.05,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M301.53,297.25l-1.63-.94a1.07,1.07,0,0,0-1,.05.09.09,0,0,1-.06,0,3.54,3.54,0,0,0-1.15,1.21l1.62.95a3.6,3.6,0,0,1,1.16-1.22l.06,0a1.08,1.08,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M296.18,301.94l-1.62-.95c-.15,2.51.47,4,1.46,4.58l1.63.94c-1-.57-1.61-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.38 292.38 288.76 291.44 288.73 291.45 290.35 292.4 290.38 292.38",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,298.5l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0,1.63.94.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M298.07,298.59l-1.63-.94a4.51,4.51,0,0,0-1.86,3.33l1.63.94A4.53,4.53,0,0,1,298.07,298.59Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M298.07,298.59l-1.63-.94a4.51,4.51,0,0,0-1.86,3.33l1.63.94a4.53,4.53,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M298.07,298.59a4.53,4.53,0,0,0-1.86,3.33l0,0c-.24,4.39,1.85,5.68,4.16,4.34s3.8-4.3,4.13-8.73c.08-1.35-.63-2-1.61-1.5l-.06,0a3.39,3.39,0,0,0-1.17,1.23,1,1,0,0,0-1.15,0l-.06,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M284.83,292.18l.05,16.36a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,284.83,292.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M284.83,292.18l.05,16.36a.48.48,0,0,0,.29.41l.15.07-.05-16.37-.15-.07a.48.48,0,0,1-.29-.4Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M285.27,292.65l.05,16.37a1.21,1.21,0,0,0,.34.09l-.05-16.37a1,1,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M285.61,292.74l.05,16.37a1.51,1.51,0,0,0,.93-.16l.06,0,0-16.37-.05,0a1.56,1.56,0,0,1-.94.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M286.6,292.55l0,16.37a1.13,1.13,0,0,0,.19-.19l0-16.37a.85.85,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M286.79,292.36l0,16.37a.49.49,0,0,0,.05-.19l-.05-16.37a.45.45,0,0,1,0,.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M285.13,291.76c-.4.22-.41.59,0,.82a1.57,1.57,0,0,0,1.43,0,.43.43,0,0,0,0-.82A1.55,1.55,0,0,0,285.13,291.76Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M290.23,288.32l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0a3.51,3.51,0,0,0-1.17,1.24l1.63,1a3.43,3.43,0,0,1,1.17-1.24l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M287.86,289.58l-1.64-.94a1,1,0,0,0-1,.06l-.06,0A3.42,3.42,0,0,0,284,290l1.62.94a3.47,3.47,0,0,1,1.16-1.21l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M282.51,294.27l-1.63-.95c-.14,2.51.49,4,1.47,4.58l1.63.94c-1-.57-1.61-2.06-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "276.71 284.72 275.08 283.77 275.06 283.79 276.69 284.73 276.71 284.72",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5,290.83l-1.63-.95a1.08,1.08,0,0,0-1,.06l-.06,0,1.63.95a.09.09,0,0,1,.06,0,1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4,290.93l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.94A4.46,4.46,0,0,1,284.4,290.93Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4,290.93l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.94a4.46,4.46,0,0,1,1.86-3.32Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M284.4,290.93a4.46,4.46,0,0,0-1.86,3.32l0,0c-.25,4.39,1.85,5.68,4.16,4.34s3.8-4.29,4.12-8.73c.09-1.34-.63-2-1.6-1.5l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.47,3.47,0,0,0-1.16,1.21,1,1,0,0,0-1.13,0A.09.09,0,0,0,284.4,290.93Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M271.47,284.5l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l0-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,271.47,284.5Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M271.47,284.5l0,16.37a.5.5,0,0,0,.29.41l.15.07,0-16.37-.14-.07a.51.51,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M271.91,285l0,16.37a1.37,1.37,0,0,0,.35.08l-.05-16.36a2,2,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M272.26,285.07l.05,16.36a1.52,1.52,0,0,0,.93-.15.1.1,0,0,0,.05,0l-.05-16.37a.1.1,0,0,1-.05,0,1.6,1.6,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M273.24,284.87l.05,16.37a.49.49,0,0,0,.19-.19l-.05-16.37a.49.49,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M273.43,284.68l.05,16.37a.32.32,0,0,0,0-.19l0-16.37a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M271.77,284.08c-.39.23-.4.6,0,.83a1.55,1.55,0,0,0,1.42,0c.39-.23.4-.6,0-.83A1.61,1.61,0,0,0,271.77,284.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M276.89,280.65l-1.64-.95a1.06,1.06,0,0,0-1,.06l-.06,0A3.43,3.43,0,0,0,273,281l1.62.94a3.53,3.53,0,0,1,1.18-1.24l.06,0a1,1,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M274.5,281.91l-1.62-1a1.08,1.08,0,0,0-1.05.06l-.06,0a3.47,3.47,0,0,0-1.16,1.21l1.63,1A3.51,3.51,0,0,1,273.4,282l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M269.16,286.59l-1.63-.94c-.14,2.51.48,4,1.47,4.58l1.62.94c-1-.58-1.61-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.36 277.05 261.73 276.1 261.7 276.11 263.33 277.06 263.36 277.05",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M272.15,283.16l-1.63-1a1.06,1.06,0,0,0-1,.06l-.06,0,1.62.94.06,0a1.05,1.05,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M271,283.25l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94A4.52,4.52,0,0,1,271,283.25Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M271,283.25l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94a4.52,4.52,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M271,283.25a4.52,4.52,0,0,0-1.85,3.33h0c-.25,4.4,1.84,5.68,4.16,4.35s3.79-4.3,4.13-8.74c.08-1.34-.64-2-1.61-1.49l-.06,0A3.53,3.53,0,0,0,274.6,282a1,1,0,0,0-1.14,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,276.83l.05,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.38a.53.53,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,257.8,276.83Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,276.83l.05,16.37a.5.5,0,0,0,.29.41l.15.07,0-16.37-.16-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M258.25,277.31l0,16.37a2,2,0,0,0,.35.09l-.05-16.37a1.21,1.21,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M258.59,277.4l.05,16.37a1.53,1.53,0,0,0,.93-.16l.05,0,0-16.37-.06,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M259.58,277.21l0,16.37a.57.57,0,0,0,.19-.19l0-16.37a1.13,1.13,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M259.77,277l0,16.37a.38.38,0,0,0,.06-.19l-.05-16.38a.49.49,0,0,1-.05.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M258.1,276.41c-.39.23-.4.6,0,.83a1.57,1.57,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.61,1.61,0,0,0,258.1,276.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M263.21,273l-1.63-1a1,1,0,0,0-1,.07l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.62.94a3.66,3.66,0,0,1,1.17-1.23l.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M260.83,274.24l-1.63-.94a1,1,0,0,0-1,.06l-.06,0A3.45,3.45,0,0,0,257,274.6l1.62.95a3.51,3.51,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M255.49,278.93l-1.63-.95c-.14,2.5.48,4,1.47,4.58l1.62.94c-1-.57-1.6-2.07-1.46-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.69 269.38 248.06 268.43 248.03 268.44 249.66 269.39 249.69 269.38",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M258.48,275.49l-1.63-.95a1.06,1.06,0,0,0-1,.06l-.06,0,1.62.94.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M257.37,275.58l-1.62-.94a4.5,4.5,0,0,0-1.87,3.33l1.64.94A4.49,4.49,0,0,1,257.37,275.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M257.37,275.58l-1.62-.94a4.5,4.5,0,0,0-1.87,3.33l1.64.94a4.49,4.49,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M257.37,275.58a4.49,4.49,0,0,0-1.85,3.33l0,0c-.25,4.39,1.84,5.68,4.15,4.34s3.8-4.29,4.13-8.73c.09-1.35-.63-2-1.6-1.5l-.07,0a3.66,3.66,0,0,0-1.17,1.23,1,1,0,0,0-1.14,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M244.33,268.69l0,16.36a.51.51,0,0,0,.29.42,1.61,1.61,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l0-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,244.33,268.69Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M244.33,268.69l0,16.36a.51.51,0,0,0,.29.42.67.67,0,0,0,.15.06l0-16.37a.51.51,0,0,1-.15-.07.48.48,0,0,1-.29-.4Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M244.77,269.16l0,16.37a1,1,0,0,0,.34.09l0-16.37a1,1,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M245.11,269.25l0,16.37a1.59,1.59,0,0,0,.93-.15l.06,0-.05-16.37-.06,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M246.1,269.06l.05,16.37a.85.85,0,0,0,.19-.19l-.06-16.37a.64.64,0,0,1-.18.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M246.28,268.87l.06,16.37a.45.45,0,0,0,0-.19l0-16.37a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M244.62,268.27a.43.43,0,0,0,0,.82,1.55,1.55,0,0,0,1.42,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,244.62,268.27Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M249.74,264.83l-1.63-.95a1.06,1.06,0,0,0-1,.07l-.07,0a3.39,3.39,0,0,0-1.17,1.23l1.63.95a3.43,3.43,0,0,1,1.17-1.24l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M247.35,266.1l-1.62-1a1.08,1.08,0,0,0-1,.06l-.06,0a3.48,3.48,0,0,0-1.15,1.22l1.63,1a3.48,3.48,0,0,1,1.15-1.22l.06,0a1.05,1.05,0,0,1,1,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M242,270.78l-1.62-.94c-.15,2.5.48,4,1.46,4.57l1.63.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "236.21 261.23 234.58 260.29 234.56 260.3 236.19 261.25 236.21 261.23",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M245,267.34l-1.63-.94a1,1,0,0,0-1,.06l-.06,0,1.62.95.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M243.89,267.44l-1.62-.95a4.53,4.53,0,0,0-1.86,3.33l1.63.95A4.5,4.5,0,0,1,243.89,267.44Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M243.89,267.44l-1.62-.95a4.53,4.53,0,0,0-1.86,3.33l1.63.95a4.5,4.5,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M243.89,267.44a4.5,4.5,0,0,0-1.85,3.33h0c-.24,4.39,1.85,5.68,4.16,4.35s3.8-4.3,4.12-8.74c.09-1.34-.63-2-1.6-1.5l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.48,3.48,0,0,0-1.15,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M230.65,261l.06,16.37a.47.47,0,0,0,.29.4,1.55,1.55,0,0,0,1.42,0,.52.52,0,0,0,.3-.42L232.67,261a.52.52,0,0,1-.3.42,1.61,1.61,0,0,1-1.42,0A.52.52,0,0,1,230.65,261Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M230.65,261l.06,16.37a.47.47,0,0,0,.29.4.53.53,0,0,0,.15.08l-.05-16.37-.15-.07a.52.52,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M231.1,261.5l.05,16.37a1.21,1.21,0,0,0,.34.08l-.05-16.37a1.21,1.21,0,0,1-.34-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M231.44,261.58l.05,16.37a1.52,1.52,0,0,0,.93-.15l.05,0-.05-16.37,0,0a1.59,1.59,0,0,1-.93.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M232.42,261.39l.05,16.37a.49.49,0,0,0,.19-.19l0-16.37a.43.43,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M232.61,261.2l0,16.37a.33.33,0,0,0,.06-.19L232.67,261a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M231,260.6a.44.44,0,0,0,0,.83,1.61,1.61,0,0,0,1.42,0c.39-.23.4-.6,0-.83A1.55,1.55,0,0,0,231,260.6Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M236.07,257.16l-1.63-.94a1.05,1.05,0,0,0-1.05.06l-.06,0a3.6,3.6,0,0,0-1.17,1.24l1.63.95a3.43,3.43,0,0,1,1.17-1.24l.06,0a1.06,1.06,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M233.68,258.43l-1.62-.95a1.08,1.08,0,0,0-1.05.06l0,0a3.53,3.53,0,0,0-1.17,1.22l1.63.95a3.51,3.51,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M228.34,263.11l-1.63-.94c-.14,2.51.48,4,1.47,4.57l1.63.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.54 253.56 220.91 252.62 220.88 252.63 222.52 253.58 222.54 253.56",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M231.33,259.67l-1.63-.94a1,1,0,0,0-1,.06l-.06,0,1.62.94.06,0a1.06,1.06,0,0,1,1.05-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M230.22,259.77l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.5,4.5,0,0,1,230.22,259.77Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M230.22,259.77l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94a4.5,4.5,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M230.22,259.77a4.5,4.5,0,0,0-1.85,3.33h0c-.25,4.39,1.84,5.68,4.16,4.35s3.79-4.3,4.12-8.74c.09-1.34-.63-2-1.6-1.49l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3,253.34l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.48.48,0,0,0,.29-.41l0-16.37a.52.52,0,0,1-.3.42,1.61,1.61,0,0,1-1.42,0A.52.52,0,0,1,217.3,253.34Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3,253.34l0,16.37a.5.5,0,0,0,.29.41l.15.08,0-16.37-.14-.07a.52.52,0,0,1-.3-.42Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M217.74,253.83l0,16.37a2,2,0,0,0,.35.08l0-16.37a2,2,0,0,1-.35-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M218.09,253.91l0,16.37a1.54,1.54,0,0,0,.93-.16l.05,0-.05-16.37,0,0a1.61,1.61,0,0,1-.93.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M219.07,253.72l.05,16.37a.57.57,0,0,0,.19-.19l-.05-16.37a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M219.26,253.53l.05,16.37a.34.34,0,0,0,.05-.19l0-16.37a.35.35,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M217.6,252.93a.44.44,0,0,0,0,.83,1.61,1.61,0,0,0,1.42,0,.44.44,0,0,0,0-.83A1.55,1.55,0,0,0,217.6,252.93Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M222.71,249.49l-1.62-1a1.06,1.06,0,0,0-1.05.07l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.62,1a3.6,3.6,0,0,1,1.17-1.24l.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M220.33,250.76l-1.63-.95a1,1,0,0,0-1,.06l-.06,0a3.51,3.51,0,0,0-1.16,1.22l1.63.95a3.42,3.42,0,0,1,1.16-1.22l.05,0a1,1,0,0,1,1.05-.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M215,255.44l-1.63-.95c-.14,2.51.48,4,1.47,4.58l1.62.95c-1-.58-1.6-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.19 245.89 207.56 244.94 207.54 244.96 209.16 245.91 209.19 245.89",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M218,252l-1.63-.95a1.06,1.06,0,0,0-1,.07l-.05,0,1.62.95.06,0a1.05,1.05,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M216.87,252.1l-1.62-.95a4.49,4.49,0,0,0-1.86,3.33l1.62,1A4.52,4.52,0,0,1,216.87,252.1Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M216.87,252.1l-1.62-.95a4.49,4.49,0,0,0-1.86,3.33l1.62,1a4.52,4.52,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M216.87,252.1a4.52,4.52,0,0,0-1.86,3.33h0c-.25,4.39,1.84,5.68,4.15,4.34s3.8-4.29,4.13-8.73c.09-1.35-.63-2-1.6-1.5l-.07,0a3.6,3.6,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.05,0a3.42,3.42,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M277.47,312.09l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.53.53,0,0,0,.3-.41l-.06-16.37a.5.5,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,277.47,312.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M277.47,312.09l0,16.37a.5.5,0,0,0,.29.41l.15.07,0-16.37-.15-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M277.91,312.57l0,16.37a2,2,0,0,0,.35.09l-.05-16.37a1.28,1.28,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M278.26,312.66l.05,16.37a1.54,1.54,0,0,0,.93-.16l.05,0-.05-16.37-.05,0a1.62,1.62,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M279.24,312.47l.05,16.37a.57.57,0,0,0,.19-.19l-.05-16.37a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M279.43,312.28l.05,16.37a.38.38,0,0,0,.06-.19l-.06-16.37a.36.36,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M277.76,311.67a.44.44,0,0,0,0,.83,1.57,1.57,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.63,1.63,0,0,0,277.76,311.67Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M282.88,308.24l-1.63-.95a1,1,0,0,0-1,.07l-.07,0a3.49,3.49,0,0,0-1.16,1.24l1.63.94a3.37,3.37,0,0,1,1.16-1.23l.06,0a1,1,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5,309.5l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.42,3.42,0,0,0-1.16,1.22l1.62.94a3.53,3.53,0,0,1,1.17-1.22l.05,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M275.15,314.19l-1.62-.95c-.14,2.51.47,4,1.47,4.58l1.62.94c-1-.57-1.6-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.36 304.64 267.73 303.69 267.7 303.7 269.32 304.65 269.36 304.64",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M278.14,310.75l-1.62-.95a1.08,1.08,0,0,0-1,.06l-.06,0,1.63.94.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M277,310.84l-1.63-.94a4.47,4.47,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,277,310.84Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M277,310.84l-1.63-.94a4.47,4.47,0,0,0-1.85,3.33l1.62.94a4.53,4.53,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M277,310.84a4.53,4.53,0,0,0-1.86,3.33l0,0c-.24,4.39,1.85,5.68,4.16,4.34s3.8-4.3,4.13-8.73c.08-1.35-.63-2-1.61-1.5l-.06,0a3.37,3.37,0,0,0-1.16,1.23,1,1,0,0,0-1.16,0l-.05,0a3.53,3.53,0,0,0-1.17,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M263.8,304.42l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.48.48,0,0,1-.29.41,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,263.8,304.42Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M263.8,304.42l.05,16.37a.48.48,0,0,0,.29.41.69.69,0,0,0,.15.07l-.05-16.37-.15-.07a.48.48,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M264.24,304.9l.05,16.37a1.21,1.21,0,0,0,.34.09L264.58,305a1.31,1.31,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M264.58,305l.05,16.37a1.51,1.51,0,0,0,.93-.16l.06,0-.05-16.37-.05,0a1.56,1.56,0,0,1-.94.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M265.57,304.8l.05,16.37a.68.68,0,0,0,.19-.19l-.05-16.37a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M265.76,304.61l.05,16.37a.34.34,0,0,0,.05-.19l-.05-16.37a.45.45,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M264.1,304a.43.43,0,0,0,0,.82,1.57,1.57,0,0,0,1.43,0c.39-.23.4-.6,0-.82A1.55,1.55,0,0,0,264.1,304Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M269.21,300.57l-1.63-.95a1.06,1.06,0,0,0-1.05.07l-.06,0A3.6,3.6,0,0,0,265.3,301l1.64,1a3.33,3.33,0,0,1,1.16-1.24l.06,0a1.08,1.08,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M266.83,301.83l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.51,3.51,0,0,0-1.16,1.22l1.62.94a3.6,3.6,0,0,1,1.16-1.22s0,0,.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M261.48,306.52l-1.62-.95c-.15,2.51.48,4,1.46,4.58l1.63.94c-1-.57-1.61-2.06-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.69 296.97 254.06 296.02 254.03 296.04 255.66 296.99 255.69 296.97",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M264.47,303.08l-1.62-.95a1.08,1.08,0,0,0-1.05.07l-.06,0,1.63.95s0,0,.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M263.37,303.18l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95A4.49,4.49,0,0,1,263.37,303.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M263.37,303.18l-1.63-.95a4.51,4.51,0,0,0-1.86,3.33l1.63.95a4.49,4.49,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M263.37,303.18a4.49,4.49,0,0,0-1.86,3.33h0c-.24,4.39,1.85,5.68,4.16,4.34s3.8-4.29,4.13-8.73c.08-1.34-.63-2-1.61-1.5l-.06,0a3.33,3.33,0,0,0-1.16,1.24,1,1,0,0,0-1.15,0s0,0-.07,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0S263.38,303.16,263.37,303.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44,296.75l.05,16.37a.49.49,0,0,0,.3.41,1.61,1.61,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l0-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.51.51,0,0,1,250.44,296.75Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M250.44,296.75l.05,16.37a.49.49,0,0,0,.3.41.69.69,0,0,0,.15.07l-.05-16.37-.15-.07a.51.51,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M250.89,297.23l.05,16.37a1.69,1.69,0,0,0,.34.09l-.05-16.37a1.69,1.69,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M251.23,297.32l.05,16.37a1.53,1.53,0,0,0,.93-.16.1.1,0,0,0,0,0l0-16.36-.06,0a1.6,1.6,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M252.22,297.13l0,16.36a.49.49,0,0,0,.19-.19l0-16.37a.71.71,0,0,1-.19.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M252.41,296.93l0,16.37a.33.33,0,0,0,.06-.19l0-16.37a.41.41,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M250.74,296.33a.44.44,0,0,0,0,.83,1.55,1.55,0,0,0,1.42,0,.44.44,0,0,0,0-.83A1.63,1.63,0,0,0,250.74,296.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M255.85,292.9l-1.62-.95a1.08,1.08,0,0,0-1,.06l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.63.94a3.43,3.43,0,0,1,1.17-1.24l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M253.47,294.16l-1.62-1a1.08,1.08,0,0,0-1,.06l-.06,0a3.54,3.54,0,0,0-1.15,1.21l1.62,1a3.6,3.6,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M248.13,298.84l-1.63-.94c-.14,2.51.48,4,1.47,4.57l1.63.95c-1-.57-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.33 289.29 240.71 288.35 240.68 288.36 242.3 289.31 242.33 289.29",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M251.12,295.41l-1.63-1a1.06,1.06,0,0,0-1,.06l-.06,0,1.62.94.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M250,295.5l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.52,4.52,0,0,1,250,295.5Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M250,295.5l-1.62-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.52,4.52,0,0,1,250,295.5Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M250,295.5a4.52,4.52,0,0,0-1.85,3.33h0c-.25,4.4,1.84,5.68,4.16,4.35s3.79-4.3,4.13-8.74c.08-1.34-.64-2-1.61-1.49l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M236.77,289.08l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.38a.52.52,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.5.5,0,0,1,236.77,289.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M236.77,289.08l0,16.37a.5.5,0,0,0,.29.41l.16.07-.05-16.37-.16-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M237.22,289.56l.05,16.37a1.69,1.69,0,0,0,.34.09l-.05-16.37a1.69,1.69,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M237.56,289.65l.05,16.37a1.53,1.53,0,0,0,.93-.16l.06,0,0-16.37-.06,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M238.55,289.46l0,16.37a.67.67,0,0,0,.18-.2l0-16.37a.89.89,0,0,1-.19.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M238.74,289.26l0,16.37a.32.32,0,0,0,.06-.18l-.05-16.38a.41.41,0,0,1,0,.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M237.07,288.67a.43.43,0,0,0,0,.82,1.57,1.57,0,0,0,1.43,0c.4-.23.4-.6,0-.82A1.57,1.57,0,0,0,237.07,288.67Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M242.19,285.23l-1.63-1a1.08,1.08,0,0,0-1.05.06l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.62.95a3.57,3.57,0,0,1,1.18-1.25l.06,0a1,1,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M239.8,286.49l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.4,3.4,0,0,0-1.15,1.22l1.62.94a3.51,3.51,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M234.46,291.18l-1.63-.95c-.14,2.51.48,4,1.47,4.58l1.62.94c-1-.57-1.6-2.07-1.46-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.66 281.63 227.03 280.68 227 280.69 228.63 281.64 228.66 281.63",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M237.45,287.74l-1.63-.95a1.06,1.06,0,0,0-1,.06l-.06,0,1.62.94.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M236.34,287.83l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94A4.49,4.49,0,0,1,236.34,287.83Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M236.34,287.83l-1.62-.94a4.46,4.46,0,0,0-1.86,3.33l1.63.94a4.49,4.49,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M236.34,287.83a4.49,4.49,0,0,0-1.85,3.33l0,0c-.24,4.39,1.84,5.68,4.16,4.34s3.79-4.29,4.12-8.73c.09-1.35-.63-2-1.6-1.5l-.06,0a3.57,3.57,0,0,0-1.18,1.25,1,1,0,0,0-1.14,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3,280.94l0,16.36a.51.51,0,0,0,.29.42,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l-.05-16.37a.5.5,0,0,1-.29.41,1.51,1.51,0,0,1-1.43,0A.5.5,0,0,1,223.3,280.94Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3,280.94l0,16.36a.51.51,0,0,0,.29.42l.15.07,0-16.37-.15-.08a.5.5,0,0,1-.29-.4Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M223.74,281.42l0,16.37a1.87,1.87,0,0,0,.34.08l0-16.37a1.28,1.28,0,0,1-.35-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M224.09,281.5l0,16.37a1.63,1.63,0,0,0,.94-.15s0,0,.05,0l-.05-16.37,0,0a1.54,1.54,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M225.07,281.31l.05,16.37a.57.57,0,0,0,.19-.19l-.05-16.37a.85.85,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M225.26,281.12l.05,16.37a.45.45,0,0,0,.05-.19l-.05-16.37a.45.45,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59,280.52a.43.43,0,0,0,0,.82,1.51,1.51,0,0,0,1.43,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,223.59,280.52Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M228.71,277.08l-1.63-.95a1,1,0,0,0-1,.07l-.07,0a3.66,3.66,0,0,0-1.17,1.23l1.63.95a3.43,3.43,0,0,1,1.17-1.24l.06,0a1.06,1.06,0,0,1,1.05-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M226.33,278.34l-1.63-.94a1,1,0,0,0-1,.06l-.07,0a3.48,3.48,0,0,0-1.15,1.22l1.63,1a3.48,3.48,0,0,1,1.15-1.22l.06,0a1.08,1.08,0,0,1,1.05-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M221,283l-1.62-.94c-.14,2.5.48,4,1.46,4.57l1.63.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "215.19 273.48 213.56 272.54 213.53 272.55 215.16 273.5 215.19 273.48",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M224,279.59l-1.62-.94a1.06,1.06,0,0,0-1,.06l-.07,0,1.62.95.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M222.86,279.69l-1.62-.95a4.49,4.49,0,0,0-1.85,3.33L221,283A4.53,4.53,0,0,1,222.86,279.69Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M222.86,279.69l-1.62-.95a4.49,4.49,0,0,0-1.85,3.33L221,283a4.53,4.53,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M222.86,279.69A4.53,4.53,0,0,0,221,283h0c-.24,4.4,1.85,5.68,4.16,4.35s3.8-4.3,4.12-8.74c.09-1.34-.63-2-1.6-1.49l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.48,3.48,0,0,0-1.15,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62,273.27l.06,16.37a.53.53,0,0,0,.29.41,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l-.05-16.37a.52.52,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.55.55,0,0,1,209.62,273.27Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62,273.27l.06,16.37a.53.53,0,0,0,.29.41l.15.07-.05-16.37-.15-.07a.55.55,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M210.07,273.75l.05,16.37a1.21,1.21,0,0,0,.34.08l0-16.37a1.28,1.28,0,0,1-.35-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M210.42,273.83l0,16.37a1.56,1.56,0,0,0,.94-.15l0,0,0-16.36-.06,0a1.57,1.57,0,0,1-.92.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M211.4,273.65l0,16.36a.68.68,0,0,0,.19-.19l-.06-16.37a.56.56,0,0,1-.18.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M211.58,273.45l.06,16.37a.41.41,0,0,0,.05-.19l-.05-16.37a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M209.92,272.85a.44.44,0,0,0,0,.83,1.55,1.55,0,0,0,1.42,0,.44.44,0,0,0,0-.83A1.57,1.57,0,0,0,209.92,272.85Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M215,269.41l-1.63-.94a1,1,0,0,0-1,.06l-.07,0a3.79,3.79,0,0,0-1.17,1.24l1.63.95a3.51,3.51,0,0,1,1.17-1.24l.07,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M212.65,270.68l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0a3.6,3.6,0,0,0-1.16,1.22l1.63.95a3.6,3.6,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M207.31,275.36l-1.62-.94c-.14,2.5.47,4,1.46,4.57l1.63.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "201.51 265.81 199.88 264.87 199.86 264.88 201.49 265.83 201.51 265.81",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M210.3,271.93l-1.63-.95a1,1,0,0,0-1,.06l-.06,0,1.63.95.06,0a1,1,0,0,1,1-.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2,272l-1.63-.95a4.53,4.53,0,0,0-1.86,3.34l1.63.94A4.48,4.48,0,0,1,209.2,272Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2,272l-1.63-.95a4.53,4.53,0,0,0-1.86,3.34l1.63.94A4.48,4.48,0,0,1,209.2,272Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2,272a4.48,4.48,0,0,0-1.86,3.33h0c-.25,4.39,1.84,5.68,4.16,4.35s3.8-4.3,4.13-8.74c.08-1.34-.64-2-1.6-1.49l-.07,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M196.27,265.59l.06,16.37a.49.49,0,0,0,.28.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l-.05-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.49.49,0,0,1,196.27,265.59Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M196.27,265.59l.06,16.37a.49.49,0,0,0,.28.41l.15.08,0-16.37-.15-.08a.49.49,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M196.72,266.08l0,16.37a1.37,1.37,0,0,0,.35.08l-.05-16.37a1.69,1.69,0,0,1-.34-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M197.06,266.16l.05,16.37a1.51,1.51,0,0,0,.93-.16l.05,0,0-16.37-.06,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M198.05,266l0,16.37a.61.61,0,0,0,.2-.19l0-16.37a.85.85,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M198.24,265.78l0,16.37a.45.45,0,0,0,.05-.19l-.05-16.37a.45.45,0,0,1,0,.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M196.57,265.18a.43.43,0,0,0,0,.82,1.55,1.55,0,0,0,1.42,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,196.57,265.18Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M201.68,261.74l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0a3.51,3.51,0,0,0-1.17,1.24l1.63.94a3.54,3.54,0,0,1,1.16-1.23l.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M199.3,263l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.6,3.6,0,0,0-1.16,1.22l1.63.94a3.56,3.56,0,0,1,1.16-1.21l.06,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M194,267.69l-1.63-.95c-.14,2.51.48,4,1.47,4.58l1.63.95c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.16 258.14 186.53 257.19 186.51 257.21 188.13 258.15 188.16 258.14",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M197,264.25l-1.63-.94a1,1,0,0,0-1,.06l-.06,0,1.62,1,.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M195.84,264.35l-1.62-1a4.53,4.53,0,0,0-1.86,3.33l1.63.95A4.48,4.48,0,0,1,195.84,264.35Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M195.84,264.35l-1.62-1a4.53,4.53,0,0,0-1.86,3.33l1.63.95a4.48,4.48,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M195.84,264.35a4.48,4.48,0,0,0-1.85,3.33h0c-.25,4.39,1.84,5.68,4.16,4.34s3.8-4.29,4.12-8.73c.09-1.34-.63-2-1.6-1.5l-.07,0a3.54,3.54,0,0,0-1.16,1.23,1,1,0,0,0-1.15,0l-.06,0a3.56,3.56,0,0,0-1.16,1.21,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M253.66,326.06l.05,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.52.52,0,0,0,.3-.42l-.05-16.37a.49.49,0,0,1-.29.42,1.57,1.57,0,0,1-1.43,0A.48.48,0,0,1,253.66,326.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M253.66,326.06l.05,16.37a.48.48,0,0,0,.29.41l.15.07-.05-16.37-.15-.07a.48.48,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M254.1,326.54l.05,16.37a1.3,1.3,0,0,0,.34.08l-.05-16.36a1.89,1.89,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M254.44,326.63l.05,16.36a1.44,1.44,0,0,0,.93-.15l.06,0,0-16.38-.05,0a1.64,1.64,0,0,1-.94.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M255.43,326.43l0,16.38a.59.59,0,0,0,.19-.2l0-16.37a.5.5,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M255.62,326.24l0,16.37a.41.41,0,0,0,.05-.19l-.05-16.37a.41.41,0,0,1,0,.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M254,325.64a.44.44,0,0,0,0,.83,1.57,1.57,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.63,1.63,0,0,0,254,325.64Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M259.06,322.2l-1.62-.94a1.06,1.06,0,0,0-1,.06l-.07,0a3.6,3.6,0,0,0-1.17,1.24l1.63.94A3.51,3.51,0,0,1,258,322.3l.06,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M256.69,323.47l-1.63-.94a1,1,0,0,0-1,.05l-.07,0a3.48,3.48,0,0,0-1.15,1.22l1.63.94a3.48,3.48,0,0,1,1.15-1.22l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M251.34,328.16l-1.62-1c-.15,2.5.48,4,1.46,4.58l1.63.94c-1-.58-1.61-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.55 318.61 243.92 317.66 243.89 317.67 245.51 318.62 245.55 318.61",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M254.33,324.72l-1.62-1a1.05,1.05,0,0,0-1.05.06l-.06,0,1.62.94.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M253.22,324.81l-1.62-.94a4.49,4.49,0,0,0-1.86,3.32l1.63.95A4.52,4.52,0,0,1,253.22,324.81Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M253.22,324.81l-1.62-.94a4.49,4.49,0,0,0-1.86,3.32l1.63.95a4.52,4.52,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M253.22,324.81a4.52,4.52,0,0,0-1.85,3.33l0,0c-.24,4.39,1.85,5.67,4.16,4.34s3.8-4.3,4.12-8.73c.09-1.35-.63-2-1.6-1.5l-.06,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.48,3.48,0,0,0-1.15,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M240,318.39l.06,16.37a.49.49,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.51.51,0,0,0,.29-.41L242,318.38a.51.51,0,0,1-.3.42,1.55,1.55,0,0,1-1.42,0A.54.54,0,0,1,240,318.39Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M240,318.39l.06,16.37a.49.49,0,0,0,.29.41l.15.07,0-16.37a.69.69,0,0,1-.15-.07.54.54,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M240.43,318.87l0,16.37a1.21,1.21,0,0,0,.34.09l0-16.37a1.89,1.89,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M240.77,319l0,16.37a1.64,1.64,0,0,0,.94-.16l.05,0-.05-16.37-.06,0a1.53,1.53,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M241.76,318.77l.05,16.37A1.13,1.13,0,0,0,242,335l-.06-16.38a.67.67,0,0,1-.18.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M241.94,318.57,242,335a.49.49,0,0,0,.05-.19L242,318.38a.31.31,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M240.28,318a.44.44,0,0,0,0,.83,1.55,1.55,0,0,0,1.42,0,.44.44,0,0,0,0-.83A1.63,1.63,0,0,0,240.28,318Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M245.4,314.54l-1.63-1a1,1,0,0,0-1,.07.15.15,0,0,0-.07,0,3.51,3.51,0,0,0-1.17,1.24l1.63.94a3.51,3.51,0,0,1,1.17-1.24l.06,0a1.05,1.05,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M243,315.8l-1.62-.94a1,1,0,0,0-1,.06l-.06,0a3.6,3.6,0,0,0-1.16,1.22l1.63.94a3.6,3.6,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M237.67,320.49l-1.62-.95c-.14,2.51.47,4,1.46,4.58l1.63.94c-1-.57-1.61-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.87 310.94 230.25 309.99 230.22 310 231.85 310.95 231.87 310.94",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M240.66,317.05,239,316.1a1.06,1.06,0,0,0-1,.06l-.06,0,1.63.94.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M239.56,317.14l-1.63-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94A4.53,4.53,0,0,1,239.56,317.14Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M239.56,317.14l-1.63-.94a4.49,4.49,0,0,0-1.86,3.33l1.63.94a4.53,4.53,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M239.56,317.14a4.53,4.53,0,0,0-1.86,3.33l0,0c-.25,4.39,1.84,5.68,4.16,4.34s3.8-4.3,4.12-8.73c.09-1.35-.63-2-1.6-1.5l-.06,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.6,3.6,0,0,0-1.16,1.22,1,1,0,0,0-1.13,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M226.63,310.72l.05,16.37a.49.49,0,0,0,.29.4,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.41l0-16.37a.54.54,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.53.53,0,0,1,226.63,310.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M226.63,310.72l.05,16.37a.49.49,0,0,0,.29.4.55.55,0,0,0,.15.08l-.05-16.37-.15-.07a.53.53,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M227.07,311.2l.05,16.37a1.37,1.37,0,0,0,.35.08l-.05-16.36a2,2,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M227.42,311.29l.05,16.36a1.45,1.45,0,0,0,.93-.16.09.09,0,0,0,0,0l0-16.37-.06,0a1.6,1.6,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M228.41,311.09l0,16.37a.49.49,0,0,0,.19-.19l0-16.37a.69.69,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6,310.9l0,16.37a.33.33,0,0,0,.06-.19l0-16.37a.41.41,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M226.93,310.3c-.39.23-.4.6,0,.83a1.63,1.63,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.55,1.55,0,0,0,226.93,310.3Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M232,306.86l-1.63-.94a1.06,1.06,0,0,0-1,.06l-.06,0a3.55,3.55,0,0,0-1.17,1.25l1.63.94a3.49,3.49,0,0,1,1.16-1.24l.07,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M229.66,308.13l-1.63-.95a1.06,1.06,0,0,0-1,.06l-.06,0a3.47,3.47,0,0,0-1.16,1.21l1.63.95a3.42,3.42,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M224.32,312.81l-1.63-.94c-.14,2.51.48,4,1.47,4.57l1.62.95c-1-.58-1.6-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.52 303.26 216.89 302.32 216.86 302.33 218.49 303.28 218.52 303.26",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M227.31,309.38l-1.63-.95a1,1,0,0,0-1,.06l-.07,0,1.63.94.06,0a1,1,0,0,1,1.05-.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M226.2,309.47l-1.63-.94a4.51,4.51,0,0,0-1.85,3.32l1.63.95A4.47,4.47,0,0,1,226.2,309.47Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M226.2,309.47l-1.63-.94a4.51,4.51,0,0,0-1.85,3.32l1.63.95a4.47,4.47,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M226.2,309.47a4.47,4.47,0,0,0-1.85,3.33h0c-.25,4.39,1.84,5.68,4.15,4.35s3.8-4.3,4.13-8.74c.09-1.34-.63-2-1.6-1.5l-.07,0a3.49,3.49,0,0,0-1.16,1.24,1,1,0,0,0-1.15,0l-.06,0a3.42,3.42,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M213,303.05l0,16.37a.51.51,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.52.52,0,0,0,.3-.42L215,303a.52.52,0,0,1-.3.42,1.57,1.57,0,0,1-1.43,0A.51.51,0,0,1,213,303.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M213,303.05l0,16.37a.51.51,0,0,0,.29.41l.16.07-.05-16.37-.16-.07a.51.51,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M213.41,303.53l.05,16.37a1.69,1.69,0,0,0,.34.09l-.05-16.37a1.69,1.69,0,0,1-.34-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M213.75,303.62,213.8,320a1.6,1.6,0,0,0,.93-.16s0,0,.05,0l-.05-16.36,0,0a1.53,1.53,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M214.73,303.43l.05,16.36a.49.49,0,0,0,.19-.19l-.05-16.37a.59.59,0,0,1-.19.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M214.92,303.23,215,319.6a.35.35,0,0,0,.06-.19L215,303a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M213.26,302.63a.44.44,0,0,0,0,.83,1.57,1.57,0,0,0,1.43,0,.44.44,0,0,0,0-.83A1.61,1.61,0,0,0,213.26,302.63Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M218.37,299.2l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0a3.43,3.43,0,0,0-1.17,1.24l1.63.94a3.58,3.58,0,0,1,1.16-1.24l.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M216,300.46l-1.63-.94a1,1,0,0,0-1,.05l-.06,0a3.65,3.65,0,0,0-1.16,1.21l1.62.95a3.53,3.53,0,0,1,1.17-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M210.65,305.15,209,304.2c-.14,2.5.48,4,1.47,4.58l1.63.94c-1-.57-1.61-2.07-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "204.85 295.6 203.22 294.65 203.19 294.67 204.82 295.61 204.85 295.6",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M213.63,301.71l-1.62-.95a1.08,1.08,0,0,0-1,.06l-.06,0,1.63.94.07,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M212.53,301.8l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94A4.53,4.53,0,0,1,212.53,301.8Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M212.53,301.8l-1.63-.94a4.48,4.48,0,0,0-1.85,3.33l1.62.94a4.53,4.53,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M212.53,301.8a4.53,4.53,0,0,0-1.86,3.33l0,0c-.25,4.39,1.84,5.68,4.15,4.34s3.8-4.3,4.13-8.74c.09-1.34-.63-2-1.6-1.49l-.07,0a3.58,3.58,0,0,0-1.16,1.24,1,1,0,0,0-1.15,0l-.06,0a3.53,3.53,0,0,0-1.17,1.22,1,1,0,0,0-1.12,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M199.49,294.9l0,16.37a.48.48,0,0,0,.29.41,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l-.05-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,199.49,294.9Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M199.49,294.9l0,16.37a.48.48,0,0,0,.29.41l.15.08,0-16.38a.51.51,0,0,1-.15-.07.48.48,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M199.93,295.38l0,16.38a1.3,1.3,0,0,0,.34.08l0-16.37a1.2,1.2,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M200.28,295.47l0,16.37a1.51,1.51,0,0,0,.93-.16l.06,0-.06-16.37-.05,0a1.5,1.5,0,0,1-.92.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M201.25,295.28l.06,16.37a.53.53,0,0,0,.18-.19l0-16.37a.61.61,0,0,1-.2.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M201.45,295.09l0,16.37a.35.35,0,0,0,.06-.19l-.05-16.37a.45.45,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M199.79,294.49c-.41.23-.41.6,0,.82a1.55,1.55,0,0,0,1.42,0,.43.43,0,0,0,0-.82A1.55,1.55,0,0,0,199.79,294.49Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M204.9,291.05l-1.63-.95a1,1,0,0,0-1,.07l-.07,0a3.51,3.51,0,0,0-1.17,1.24l1.63.95a3.51,3.51,0,0,1,1.17-1.24l.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M202.51,292.31l-1.62-.94a1.05,1.05,0,0,0-1,.06l-.05,0a3.53,3.53,0,0,0-1.17,1.22l1.63.95a3.63,3.63,0,0,1,1.16-1.23l.06,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M197.17,297l-1.63-.94c-.14,2.5.48,4,1.47,4.57l1.63.94c-1-.57-1.61-2.06-1.47-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.37 287.45 189.74 286.5 189.72 286.52 191.35 287.46 191.37 287.45",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M200.16,293.56l-1.63-.95a1.06,1.06,0,0,0-1,.07l-.07,0,1.64,1s0,0,.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M199.06,293.66l-1.64-1a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.46,4.46,0,0,1,199.06,293.66Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M199.06,293.66l-1.64-1a4.55,4.55,0,0,0-1.85,3.33l1.63.95a4.46,4.46,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M199.06,293.66A4.46,4.46,0,0,0,197.2,297h0c-.24,4.39,1.84,5.68,4.16,4.34s3.8-4.29,4.13-8.73c.08-1.34-.64-2-1.61-1.5l-.06,0a3.51,3.51,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.63,3.63,0,0,0-1.16,1.23,1,1,0,0,0-1.13,0S199.07,293.64,199.06,293.66Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M185.81,287.23l.05,16.38a.49.49,0,0,0,.3.4,1.55,1.55,0,0,0,1.42,0,.49.49,0,0,0,.3-.41l0-16.37a.49.49,0,0,1-.3.41,1.55,1.55,0,0,1-1.42,0A.48.48,0,0,1,185.81,287.23Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M185.81,287.23l.05,16.38a.49.49,0,0,0,.3.4.41.41,0,0,0,.15.07l-.05-16.36-.15-.08a.48.48,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M186.26,287.72l.05,16.36a1,1,0,0,0,.34.09l-.05-16.37a1.21,1.21,0,0,1-.34-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M186.6,287.8l.05,16.37a1.51,1.51,0,0,0,.93-.16l0,0,0-16.37-.05,0a1.51,1.51,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M187.58,287.61l0,16.37a.49.49,0,0,0,.19-.19l0-16.37a.49.49,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77,287.42l0,16.37a.35.35,0,0,0,.06-.19l0-16.37a.33.33,0,0,1-.06.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M186.11,286.82a.43.43,0,0,0,0,.82,1.55,1.55,0,0,0,1.42,0,.43.43,0,0,0,0-.82A1.57,1.57,0,0,0,186.11,286.82Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,283.38l-1.62-.95a1.08,1.08,0,0,0-1,.07l-.06,0a3.6,3.6,0,0,0-1.17,1.24l1.63,1a3.43,3.43,0,0,1,1.17-1.24l.06,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84,284.65l-1.62-.95a1.08,1.08,0,0,0-1.05.06l-.06,0A3.6,3.6,0,0,0,185,285l1.63.94a3.65,3.65,0,0,1,1.16-1.21l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,289.33l-1.63-.94c-.14,2.5.48,4,1.47,4.57l1.63,1c-1-.58-1.61-2.07-1.47-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.7 279.78 176.07 278.84 176.04 278.85 177.67 279.79 177.7 279.78",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M186.49,285.89l-1.63-.94a1,1,0,0,0-1,.06l-.07,0,1.63.95.06,0a1.08,1.08,0,0,1,1.05-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M185.38,286l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95A4.5,4.5,0,0,1,185.38,286Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M185.38,286l-1.63-.95a4.55,4.55,0,0,0-1.85,3.33l1.63.95a4.5,4.5,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M185.38,286a4.5,4.5,0,0,0-1.85,3.33h0c-.24,4.39,1.84,5.68,4.16,4.35s3.8-4.3,4.12-8.74c.09-1.34-.63-2-1.6-1.49l-.06,0a3.43,3.43,0,0,0-1.17,1.24,1,1,0,0,0-1.15,0l-.06,0a3.65,3.65,0,0,0-1.16,1.21,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M172.46,279.56l0,16.37a.5.5,0,0,0,.29.41,1.57,1.57,0,0,0,1.43,0,.49.49,0,0,0,.3-.42l-.06-16.37a.46.46,0,0,1-.29.42,1.55,1.55,0,0,1-1.42,0A.49.49,0,0,1,172.46,279.56Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M172.46,279.56l0,16.37a.5.5,0,0,0,.29.41l.15.07,0-16.37-.14-.07a.49.49,0,0,1-.3-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9,280l0,16.37a2,2,0,0,0,.35.09l-.05-16.37a2,2,0,0,1-.35-.09Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M173.25,280.13l.05,16.37a1.54,1.54,0,0,0,.93-.16l.05,0-.05-16.37,0,0a1.53,1.53,0,0,1-.93.16Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#8dc63f"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M174.23,279.94l.05,16.37a.52.52,0,0,0,.19-.2l-.05-16.36a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M174.42,279.75l.05,16.36a.31.31,0,0,0,.06-.19l-.06-16.37a.35.35,0,0,1-.05.2Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c8e3e"
  })))), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76,279.15c-.4.23-.4.59,0,.82a1.55,1.55,0,0,0,1.42,0c.39-.23.4-.59,0-.82A1.55,1.55,0,0,0,172.76,279.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#222320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M177.87,275.71l-1.62-.95a1.05,1.05,0,0,0-1.05.07l-.07,0A3.49,3.49,0,0,0,174,276.1l1.62.95a3.53,3.53,0,0,1,1.18-1.24.09.09,0,0,1,.06,0,1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M175.49,277l-1.63-.94a1,1,0,0,0-1,.06l-.06,0a3.6,3.6,0,0,0-1.16,1.22l1.63.94a3.59,3.59,0,0,1,1.16-1.22l.06,0a1.06,1.06,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M170.14,281.66l-1.62-1c-.14,2.51.48,4,1.47,4.58l1.63.94c-1-.57-1.61-2.07-1.48-4.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.35 272.11 162.72 271.16 162.69 271.18 164.32 272.13 164.35 272.11",
    fill: "#8a291f"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M173.13,278.22l-1.62-1a1.06,1.06,0,0,0-1,.06l-.07,0,1.63.94.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M172,278.31l-1.63-.94a4.5,4.5,0,0,0-1.85,3.33l1.62.94A4.56,4.56,0,0,1,172,278.31Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M172,278.31l-1.63-.94a4.5,4.5,0,0,0-1.85,3.33l1.62.94a4.56,4.56,0,0,1,1.86-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f78d2a"
  }))))), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M172,278.31a4.56,4.56,0,0,0-1.86,3.33l0,0c-.24,4.39,1.85,5.68,4.16,4.34s3.8-4.29,4.13-8.73c.09-1.35-.63-2-1.6-1.5a.09.09,0,0,0-.06,0,3.53,3.53,0,0,0-1.18,1.24,1,1,0,0,0-1.14,0l-.06,0a3.59,3.59,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#ffcb05"
  }))), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M145.2,221.92c1.69,1.32,5.21,4,7.06,4.66a18.65,18.65,0,0,0,7.08.88,3.42,3.42,0,0,1,3.14,1.15l2.66,2.2c1.69,1.37,1.52,1.71,2.36,3.83.67,1.68,1.36,3.56.18,4s-2-1.1-3.09-2.61c-3,.41-5.28.5-8.1,1.63-3.86-.87-6.09-1-7.81-2.89a9.74,9.74,0,0,1-1.39-2.79l-6.77-3.77Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M167.39,238.7c-3.53,2.11-9-.76-12.45-1.48s-4.25-2.07-5.84-3.83a9.71,9.71,0,0,1-.88-2.37c1.65.6,3.5,1.47,4.64,1.21,2.84-.65,4.42-2.74,6.56-2.44,1.55.22,3,.81,5.62,3.45A20.55,20.55,0,0,1,167.39,238.7Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a978",
    fillRule: "evenodd"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M130.93,294.5,87.17,271.85a24.33,24.33,0,0,0-4.56-1.17c-8.38.4-19.86,7.07-21,4.49s.89-5.59,2.42-7.65c3.54-4.77,9.44-7.73,14.69-10.23.48-.92,1.9-1.55,3.83-2.75,1.58-1,1.23-.63,2.66-.11,4.73,1.74,5.73,3.57,6.71,5.74.61,1.35,1.85,2.08,3.92,3,10.36,3.75,24.22,1.32,33.35,6.86,13.63,8.27,16.61,23.64,8.95,25.09A10.37,10.37,0,0,1,130.93,294.5Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a978",
    fillRule: "evenodd"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M71.54,273.31c-5.05,1.71-9.27,3.37-9.94,1.86-1.2-2.7.89-5.59,2.42-7.65,3.54-4.77,9.44-7.73,14.69-10.23.48-.92,1.9-1.55,3.83-2.75,1.58-1,1.23-.64,2.66-.11,4.47,1.65,5.66,2.74,6.79,5.83-3.17-.85-6.25-.89-14.17,3.27a24.29,24.29,0,0,0-6.26,4.94C70,270.33,68.75,273.41,71.54,273.31Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#0a4747",
    fillRule: "evenodd"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M130.12,294.52,95.5,276c-1.48-3.56,6-11.56,14-10.38,7,.63,14.13,1.11,19.55,4.4,4.07,2.47,23.08,22.16,9.61,25.28A12.92,12.92,0,0,1,130.12,294.52Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#0a4747",
    fillRule: "evenodd"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M119.85,298.21l-45.7-22.06A25,25,0,0,0,69.59,275c-8.38.4-19.86,7.07-21,4.49s.9-5.59,2.42-7.65c3.54-4.77,9.44-7.73,14.69-10.23.48-.91,1.9-1.55,3.83-2.75,1.58-1,1.23-.64,2.67-.11,4.72,1.74,5.73,3.57,6.7,5.74.61,1.35,1.85,2.08,3.93,3,10.35,3.75,24.17,1.81,33.3,7.36,2.63,1.59,10.64,7.61,13.31,14.25C132.56,296.9,124.92,300.82,119.85,298.21Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M58.53,277.61c-5.06,1.72-9.28,3.38-10,1.87-1.19-2.7.9-5.59,2.42-7.65,3.54-4.77,9.44-7.73,14.69-10.23.48-.92,1.9-1.55,3.83-2.75,1.58-1,1.23-.64,2.67-.11,4.46,1.65,5.65,2.74,6.78,5.82-3.17-.84-6.25-.88-14.17,3.29a24.18,24.18,0,0,0-6.26,4.93C57,274.64,55.73,277.72,58.53,277.61Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#17595f",
    fillRule: "evenodd"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M119.35,298.48,82.57,280.34c-1.48-3.57,6.05-11.56,14-10.38,7,.63,14.13,1.11,19.55,4.4,4.07,2.47,25,22.3,11.52,25.41A12.82,12.82,0,0,1,119.35,298.48Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#145357",
    fillRule: "evenodd"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M116.15,220.72c9.49,5.67,19.25,6.53,30,10.62,2-.56,4.32-2.49,3.34-6.22l-25.26-19.69c-4.88-3.09-9.08,0-10.87,2.43C111.4,210.58,111.24,217.79,116.15,220.72Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M126.11,156.16l-.46-7.34a10.57,10.57,0,0,1,4-2.68c4.11-1.25,7.6,1.72,9.26,6.21,1.26,3.41.35,8.06,1,11.61,2.5,5.29-.33,13.33-6,15.6l-23.09,1.21Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#e9e8e8",
    fillRule: "evenodd"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M143.58,293.25c-2.86,2.94-13.38,4.5-17.72-1.2L108.34,241.7l22.09-15.19c9.76,17.47,13.89,39.21,15.49,56.75C146.2,286.28,145.8,291,143.58,293.25Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#0a4747",
    fillRule: "evenodd"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M119.42,235.79l5,4.2,1.15,6.64c.82,6.83,4.8,20.17,6.51,30.63.53,3.2,1.75,12.52,1.67,15.46a11.84,11.84,0,0,1-.63,3.57c-1.92,5.66-15.87,4.53-17.06-2.33-2.17-12.54-15.79-25.95-18.38-40.38-.68-3.75-.74-7.28.37-10.28,2.42-6.58,2.58-6.26,4.57-12.17Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#17595f",
    fillRule: "evenodd"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M119.13,179c-8.35,3.6-13,6.89-14.68,12-1.37,4.08-.49,9.54-.51,15.54,0,5.29,1.22,10.67.44,16-1,6.87-3,10.07-4.14,14.95.53,3.38,19.24,10.26,30,3,5.77-4,5.57-15.61,7-17.52,5.65-7.77,9.37-11.1,6.17-25.56-.29-1.28-4.11-14.63-6.8-16.51S126.15,177.11,119.13,179Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#3e3249",
    fillRule: "evenodd"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M118.92,167.92c.29,2-1.86,6.26-1.73,11.82.6,4.32,11.72,5.27,12.2,1.38.17-2.93,1.39-9.9,1.64-11Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f0a978",
    fillRule: "evenodd"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M134.15,152.19c2.18,4.12,2.81,6.79,2.33,10.57.51,4.74-.77,15.12-7,17-1.39.43-6.69-2.46-9.26-4.08-2.33-1.47-2.38-2.29-3.77-5.09-1.27-2.55-1.2-4.09-.47-5.24l-2.65-9.64,11.5-5.27Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M119.2,168.61c.13-3.13-1.51-3.57-2.26-3.46-3.08.46-2.26,6.11,1.32,9.67-6.44-2.79-8.18-8.08-9.05-13.82-1.06-7.09,2-13.19,8.83-15.43a5,5,0,0,0-1.84.35c3.36-2.78,10.71-1.06,12.9.07s2.91,2.15,3.83,6.16c-1.86-.35-7.11-.27-8.17.38C116.52,157.63,122,163.15,119.2,168.61Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f3f3f4",
    fillRule: "evenodd"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M116.26,189.86c5.53,8.25,2.65,29.54,2.65,40.19-1.67.73-5.54,4.67-7.63,3.19a5.4,5.4,0,0,1-1.94-2.7c-2.24-10.81-5-25.62-4.73-35.25.11-4.15,2.25-7.77,5.26-8.14A7.4,7.4,0,0,1,116.26,189.86Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M117.33,189.26c2.55,3.74,3,11.93,2.88,18.38-2.32,3-13.69,4.9-15.13,2-.53-4.41-1.84-11.16-1.75-14.64.11-3.87,2.51-7.78,5.29-9.07S115.29,186.28,117.33,189.26Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#50405c",
    fillRule: "evenodd"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M122.41,154.18c-4.66,6.16-.27,9.42-3,13.75.8,5.36-1.27,6-2.22,8.67-.67,1.9.8,3.39,2.68,5.93-2.7.92-7-.09-8.86-2.64-4.57-.11-6.85-5.22-6.07-9.12.57-2.78,2.73-5,4.16-7.6.54-6,2.14-10.68,5.08-12.52,2.16-1.35,6.21-2.93,9.92-.76Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f3f3f4",
    fillRule: "evenodd"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M123,151.78a19,19,0,0,1,10.37,6.71c3.74,5.11,8.67,2.55,9-1.09-2.85,3-4.75-2.14-6.62-4.69S131.11,147.78,123,151.78Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f3f3f4",
    fillRule: "evenodd"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M97.06,157c0-10.65,8.23-15.71,18.29-17.63,13.76-2.63,33.19,3.21,33.49,15.33.16,7-21.6,8.27-35.19,15.17C106.54,173.43,97,166.6,97.06,157Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fbab18",
    fillRule: "evenodd"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M108.9,154.8c.75-8.74,6.34-16.1,18.07-14.45,8.71.65,10.17,7.82,10.77,14.49C134.08,162.53,111.45,162.09,108.9,154.8Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fec044",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M165.23,220.49l.05,16.37a.53.53,0,0,0,.29.41,1.63,1.63,0,0,0,1.43,0,.51.51,0,0,0,.29-.42l0-16.37a.52.52,0,0,1-.3.42,1.63,1.63,0,0,1-1.43,0A.5.5,0,0,1,165.23,220.49Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#7c8e3d"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M165.23,220.49l.05,16.37a.53.53,0,0,0,.29.41l.15.07L165.67,221l-.15-.07a.5.5,0,0,1-.29-.41Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#7c8e3d"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M165.67,221l.05,16.37a1.37,1.37,0,0,0,.35.08l0-16.37a1.37,1.37,0,0,1-.35-.08Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#7c8e3d"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M166,221.05l0,16.37a1.6,1.6,0,0,0,.93-.15l.05,0,0-16.38-.06,0a1.51,1.51,0,0,1-.93.15Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#c3c63d"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M167,220.86l0,16.38a.7.7,0,0,0,.19-.2l0-16.37a.57.57,0,0,1-.19.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#7c8e3d"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M167.2,220.67l0,16.37a.34.34,0,0,0,0-.19l0-16.37a.41.41,0,0,1-.05.19Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#7c8e3d"
  })))), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M165.53,220.07a.44.44,0,0,0,0,.83,1.63,1.63,0,0,0,1.43,0c.39-.23.4-.6,0-.83A1.57,1.57,0,0,0,165.53,220.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#232320"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M170.64,216.63l-1.62-.94a1.08,1.08,0,0,0-1.05.06l-.06,0a3.6,3.6,0,0,0-1.17,1.24l1.62.95a3.6,3.6,0,0,1,1.17-1.24l.07,0a1,1,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M168.26,217.9l-1.62-1a1.08,1.08,0,0,0-1,.06l-.06,0a3.47,3.47,0,0,0-1.16,1.21l1.63,1a3.51,3.51,0,0,1,1.16-1.22l.06,0a1,1,0,0,1,1-.06Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M162.92,222.58l-1.63-.94c-.14,2.5.48,4,1.47,4.57l1.62.95c-1-.57-1.6-2.07-1.46-4.58Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  })))), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.12 213.03 155.5 212.09 155.46 212.1 157.09 213.05 157.12 213.03",
    fill: "#8a1f37"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M165.91,219.14l-1.63-.94a1,1,0,0,0-1,.06l-.07,0,1.63,1,.06,0a1.06,1.06,0,0,1,1-.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,219.24l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.95A4.49,4.49,0,0,1,164.8,219.24Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,219.24l-1.63-1a4.52,4.52,0,0,0-1.85,3.33l1.63.95a4.49,4.49,0,0,1,1.85-3.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f2682c"
  }))))), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,219.24a4.49,4.49,0,0,0-1.85,3.33h0c-.24,4.39,1.84,5.68,4.16,4.35s3.79-4.3,4.12-8.74c.09-1.34-.63-2-1.6-1.49l-.07,0a3.6,3.6,0,0,0-1.17,1.24,1,1,0,0,0-1.14,0l-.06,0a3.51,3.51,0,0,0-1.16,1.22,1,1,0,0,0-1.14,0Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fba919"
  }))), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M161.22,229.7c.1,1.93,2,3.83,4.22,4.82a9.6,9.6,0,0,1,2.4,1.3,1.11,1.11,0,0,1,.27,1.1c-.23.72-2.24,1.46-4.42.14L160.26,235c-5,.44-6.62-.07-9.66-4.19l2-3.48,5.76.89Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M146.26,234.25a.67.67,0,0,0-.06.28.66.66,0,0,0,.06.27.58.58,0,0,0-.06.26.67.67,0,0,0,.06.28,1.87,1.87,0,0,1-.06.81.71.71,0,0,0,.06.28.6.6,0,0,0-.06.27.64.64,0,0,1,0,.54.64.64,0,0,1,0,.54.66.66,0,0,0,.06.27.67.67,0,0,0-.06.28.66.66,0,0,0,.06.27.63.63,0,0,0-.06.27.66.66,0,0,0,.06.27.64.64,0,0,0,0,.54.67.67,0,0,0-.06.28.58.58,0,0,0,.06.26.67.67,0,0,0-.06.28.66.66,0,0,0,.06.27.6.6,0,0,0-.06.27.64.64,0,0,1,0,.54.6.6,0,0,0,.06.27.66.66,0,0,0-.06.27.67.67,0,0,0,.06.28.63.63,0,0,0-.06.27.64.64,0,0,1,0,.54.63.63,0,0,0,.06.27.66.66,0,0,0-.06.27.6.6,0,0,0,.06.27.71.71,0,0,0-.06.28.64.64,0,0,1,0,.54.64.64,0,0,1,0,.54c0,1,2.59,1.8,5.79,1.8s5.79-.81,5.79-1.8a.64.64,0,0,1,0-.54.64.64,0,0,1,0-.54.71.71,0,0,0-.06-.28.6.6,0,0,0,.06-.27.66.66,0,0,0-.06-.27.63.63,0,0,0,.06-.27.64.64,0,0,1,0-.54.63.63,0,0,0-.06-.27.67.67,0,0,0,.06-.28.66.66,0,0,0-.06-.27.6.6,0,0,0,.06-.27.64.64,0,0,1,0-.54.6.6,0,0,0-.06-.27.66.66,0,0,0,.06-.27.67.67,0,0,0-.06-.28.58.58,0,0,0,.06-.26.67.67,0,0,0-.06-.28.64.64,0,0,0,0-.54.66.66,0,0,0,.06-.27.63.63,0,0,0-.06-.27.66.66,0,0,0,.06-.27.67.67,0,0,0-.06-.28,1.87,1.87,0,0,1,.06-.81.64.64,0,0,1,0-.54.6.6,0,0,0-.06-.27.71.71,0,0,0,.06-.28.64.64,0,0,1,0-.54.66.66,0,0,0-.06-.27.67.67,0,0,0,.06-.28.58.58,0,0,0-.06-.26.66.66,0,0,0,.06-.27.67.67,0,0,0-.06-.28.66.66,0,0,0,.06-.27c0-1-2.6-1.8-5.79-1.8s-5.79.81-5.79,1.8A.66.66,0,0,0,146.26,234.25Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#43302c",
    fillRule: "evenodd"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M152,235.78c3.19,0,5.79-.81,5.79-1.8s-2.6-1.8-5.79-1.8-5.79.81-5.79,1.8S148.8,235.78,152,235.78Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#271e1a",
    fillRule: "evenodd"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M112.05,233.82l26,9.67,0,.08,6.82,4.82c3.06,1.77,2.75,2.25,7.89,1.28,2.53-.49,4.75-.76,5.18-3.37a29.47,29.47,0,0,0,.06-7.44c-1.2,1-2.62,2.8-5.57,1.84-.89-.29-2.89-.82-3.58-1.69.58-.39,1.14-.28,2.12-.22,1.25.65,3.9,2.14,5-.47a25,25,0,0,0-4.18-2c-1.38-.43-3.29-1.52-5.17-1a23.33,23.33,0,0,1-6,.82l-23.52-14c-2.73-2.46-8.27-3.13-9.28.67C108.79,227.51,108.44,231.53,112.05,233.82Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#f9a66c",
    fillRule: "evenodd"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M147.29,232.13a3.93,3.93,0,0,1-2.15-1.18c-.52-2.62,2.06-5.44,4.27-5.92.45-.19,2.71,1,2.76,1.49C149.57,226.44,147.36,230.1,147.29,232.13Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#5c5c5c"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M151.78,226.05c-2.57.39-4.66,3.81-4.91,6a1,1,0,0,0,.42.08c.07-2,2.28-5.69,4.88-5.61A1.05,1.05,0,0,0,151.78,226.05Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M171.25,148.8c2.69,29.32,37.87,29.32,84.58,29.32s86.71-3.57,84.57-29.32c-2-23.66-22.13-30.28-84.57-29.32C206.57,120.24,168.87,122.71,171.25,148.8Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#878385"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M194,152.29c-8.45,10.87-28,17.2-41,16.73,13.32,7.84,41.18,7.56,57.66-4.62",
    transform: "translate(-5.83 -9.54)",
    fill: "#878385"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M310.13,155.51c7.53,15.29,33.89,22.29,52.47,20.24-15.38,7.67-54.41,7.9-73.65-7.81",
    transform: "translate(-5.83 -9.54)",
    fill: "#878385"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M198.45,144.07c-.3,0-1.12-.09-2.45-.26-.09,1.14-.14,2.67-.14,4.56v4.19c.82,0,1.67,0,2.52,0a1.27,1.27,0,0,1,.93,2.16,1.34,1.34,0,0,1-.95.36l-1.61,0-1.6,0a18.16,18.16,0,0,0-1.89.16,15.92,15.92,0,0,1-1.88.17,1.31,1.31,0,0,1-.95-.37,1.23,1.23,0,0,1,0-1.79,1.41,1.41,0,0,1,1-.37,15.47,15.47,0,0,0,1.78-.14c0-.74,0-2.14,0-4.22,0-1.69.06-3.31.18-4.84l-2,0a1.3,1.3,0,0,1-.94-.36,1.22,1.22,0,0,1-.38-.91,1.18,1.18,0,0,1,.36-.89,1.38,1.38,0,0,1,.83-.37c.53,0,1.45-.07,2.76-.07a34.43,34.43,0,0,1,4.57.39,1.17,1.17,0,0,1,1.11,1.29,1.13,1.13,0,0,1-.43.94A1.23,1.23,0,0,1,198.45,144.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M201.2,144.57a1.12,1.12,0,0,1-.31-.83,21.69,21.69,0,0,1,.32-2.41,1.22,1.22,0,0,1,2-.72,1.14,1.14,0,0,1,.31.83c0,.22-.1,1-.32,2.36a1.33,1.33,0,0,1-.31.67,1.1,1.1,0,0,1-.89.42A1.13,1.13,0,0,1,201.2,144.57Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M207.86,146.84a3.8,3.8,0,0,1,2.67-1.63,2.3,2.3,0,0,1,2.11,1.09,3.87,3.87,0,0,1,1.26-.75,4.24,4.24,0,0,1,1.49-.26,2.46,2.46,0,0,1,2.48,1.82,20.22,20.22,0,0,1,.4,2.53c.18,1,.4,2.69.67,5a1,1,0,0,1-.36.88,1.4,1.4,0,0,1-.94.34,1.15,1.15,0,0,1-1.26-1.06c-.11-.64-.23-1.55-.35-2.72s-.22-2.19-.31-2.72c-.16-1.11-.38-1.67-.64-1.67a3,3,0,0,0-1,.43,6.52,6.52,0,0,0-1.12.74,26,26,0,0,0,.25,3.06,25.1,25.1,0,0,1,.26,3.06,1.18,1.18,0,0,1-.36.88,1.25,1.25,0,0,1-.92.36,1.27,1.27,0,0,1-.93-.36,1.18,1.18,0,0,1-.36-.88c0-.71-.08-1.76-.23-3.13s-.23-2.42-.23-3.13a3.57,3.57,0,0,0-.1-1,7.74,7.74,0,0,0-2.18,2.08c0,.05-.08.11-.15.2,0,1.26,0,2.24,0,3,0,.17,0,.41,0,.7s0,.52,0,.66a.94.94,0,0,1-.41.8,1.54,1.54,0,0,1-.92.27,1.07,1.07,0,0,1-1.08-.69,4.22,4.22,0,0,1-.19-1.49v-3.47c0-.31,0-.77,0-1.37s0-1,0-1.36a3.67,3.67,0,0,1,.3-1.51c.24-.56.59-.84,1-.84a1.28,1.28,0,0,1,.93.41,1.25,1.25,0,0,1,.41.89A3.42,3.42,0,0,0,207.86,146.84Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M237.23,149.54a32,32,0,0,0-.47,4.63,8.54,8.54,0,0,1-1,4.38c-.81,1.21-2.26,1.82-4.33,1.82q-3.63,0-3.63-1.44a1.1,1.1,0,0,1,.33-.83,1.19,1.19,0,0,1,.86-.32,6.18,6.18,0,0,1,1.2.16,7.6,7.6,0,0,0,1.39.16,2.45,2.45,0,0,0,2.05-.85,4.82,4.82,0,0,0,.75-2.64,3.34,3.34,0,0,1-1.07.73,3.51,3.51,0,0,1-1.31.24,4,4,0,0,1-3-1.21,4.31,4.31,0,0,1-1.16-3.09,5.59,5.59,0,0,1,1.55-4.11,5.84,5.84,0,0,1,4.34-1.62,4.83,4.83,0,0,1,1.51.21,2.37,2.37,0,0,1,1,.65,1.24,1.24,0,0,1,1.18,1.4A10.4,10.4,0,0,1,237.23,149.54Zm-3.62-1.87a3.05,3.05,0,0,0-2.46,1,3.7,3.7,0,0,0-.78,2.44,2.76,2.76,0,0,0,.42,1.67,1.46,1.46,0,0,0,1.26.56,2.13,2.13,0,0,0,1.54-.88,3.26,3.26,0,0,0,.83-1.66c.12-.6.25-1.53.41-2.79a2.49,2.49,0,0,0-.63-.28A1.78,1.78,0,0,0,233.61,147.67Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M246.77,155.61a2.67,2.67,0,0,1-1.36-.83,11.57,11.57,0,0,1-1.51.62,3.49,3.49,0,0,1-1.11.21,4.38,4.38,0,0,1-3.37-1.2,5.09,5.09,0,0,1-1.13-3.6A5.15,5.15,0,0,1,240,147a5.52,5.52,0,0,1,4-1.6,5.39,5.39,0,0,1,2,.5c.94.4,1.41.86,1.41,1.39a.91.91,0,0,1-.21.59,5.69,5.69,0,0,0-.15.92c0,.38-.05.81-.05,1.31a9,9,0,0,0,.25,2.54c0,.06.16.38.43,1a5.19,5.19,0,0,1,.37.91,1,1,0,0,1-.38.81A1.31,1.31,0,0,1,246.77,155.61Zm-2.31-6.29a6,6,0,0,1,0-.69c0-.26.07-.55.13-.86a2,2,0,0,0-.33-.14.85.85,0,0,0-.25,0,3,3,0,0,0-2.22,1,3.21,3.21,0,0,0-1,2.3,3.3,3.3,0,0,0,.44,1.88,1.55,1.55,0,0,0,1.35.63,3,3,0,0,0,1.09-.19,3.22,3.22,0,0,0,1-.56A28.46,28.46,0,0,1,244.46,149.32Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M257.16,148.37c-.05.95-.49,1.43-1.3,1.43s-1.17-.4-1.17-1.21l-.05-.94a3.81,3.81,0,0,0-3,2.15v4.7a1.2,1.2,0,0,1-.37.88,1.28,1.28,0,0,1-.92.35,1.11,1.11,0,0,1-.9-.38,1.23,1.23,0,0,1-.3-.85v-6.12c0-.19,0-.48,0-.86s0-.67,0-.86a1.28,1.28,0,0,1,.31-.88,1.27,1.27,0,0,1,2.13.72,6,6,0,0,1,3.66-1.23c1.25,0,1.87.82,1.87,2.48C257.17,148.07,257.17,148.27,257.16,148.37Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M265.35,145.72c.09-2.12.18-3.58.29-4.39a1.12,1.12,0,0,1,1.22-1.1,1.17,1.17,0,0,1,.88.35,1.21,1.21,0,0,1,.34.88c0,.91-.07,2.27-.21,4.07s-.21,3.16-.21,4.07a30,30,0,0,0,.21,4.47,1.39,1.39,0,0,1,0,.27,1.11,1.11,0,0,1-.37.86,1.28,1.28,0,0,1-.87.33,1.1,1.1,0,0,1-1-.61,3.67,3.67,0,0,1-1.31.49,8.21,8.21,0,0,1-1.41.12,4.79,4.79,0,0,1-3.47-1.33,4.63,4.63,0,0,1-1.41-3.48,5.73,5.73,0,0,1,1.42-4.05,4.78,4.78,0,0,1,3.7-1.54,5.25,5.25,0,0,1,1.25.14A2.7,2.7,0,0,1,265.35,145.72Zm-.18,2.94a2.24,2.24,0,0,0-.81-.88,2.3,2.3,0,0,0-1.17-.28,2.59,2.59,0,0,0-2.07.79,3.6,3.6,0,0,0-.69,2.4,2.32,2.32,0,0,0,.74,1.72,2.44,2.44,0,0,0,1.74.72A2.61,2.61,0,0,0,264,153a4.86,4.86,0,0,0,.86-.59c.11-.09.21-.19.31-.29Q265.14,151.63,265.17,148.66Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M274.45,155.53a5.89,5.89,0,0,1-3.64-1.06,3.9,3.9,0,0,1-1.57-3.32,6.39,6.39,0,0,1,1.24-4,4.43,4.43,0,0,1,3.72-1.81,6.16,6.16,0,0,1,2.7.52,2.27,2.27,0,0,1,1.41,2.15,2.23,2.23,0,0,1-1.15,1.82,14.7,14.7,0,0,1-2.1,1.06l-3.14,1.39A2.62,2.62,0,0,0,273,153a4.6,4.6,0,0,0,3.57-.27,2.76,2.76,0,0,1,1.24-.46.85.85,0,0,1,1,1c0,.7-.52,1.28-1.55,1.73A7.08,7.08,0,0,1,274.45,155.53Zm-.25-7.92a2.06,2.06,0,0,0-1.48.58,4,4,0,0,0-1,1.73l2.1-.9a14.9,14.9,0,0,0,2-1.06A3.41,3.41,0,0,0,274.2,147.61Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M287.79,155.76a1.15,1.15,0,0,1-1.28-1.13c-.09-.64-.17-1.28-.26-1.93a14.74,14.74,0,0,1-.14-1.93c0-.16,0-.44,0-.83s0-.67,0-.83,0-.15,0-.33a3.71,3.71,0,0,0,0-.44c0-.51-.12-.77-.37-.77a2.07,2.07,0,0,0-1.57,1,7.74,7.74,0,0,0-1.2,2.6c0,.21,0,.49-.08.85a5.92,5.92,0,0,0-.05.84,7.89,7.89,0,0,1-.06.8,8,8,0,0,0-.06.81,1.24,1.24,0,0,1-.37.91,1.33,1.33,0,0,1-.93.35,1.28,1.28,0,0,1-.93-.35,1.22,1.22,0,0,1-.36-.9,7.69,7.69,0,0,0-.06-.8c0-.36-.05-.63-.05-.81,0-.6,0-1.45.13-2.53s.13-1.93.13-2.54c0-.19,0-.48,0-.85s0-.66,0-.84a1.13,1.13,0,0,1,.37-.88,1.33,1.33,0,0,1,.93-.35c.82,0,1.25.49,1.31,1.47v.1a4,4,0,0,1,2.87-1.37,2.45,2.45,0,0,1,2.44,1.47,7.51,7.51,0,0,1,.44,3v1.27a10.65,10.65,0,0,0,.2,1.87,11.82,11.82,0,0,1,.2,1.87,1.14,1.14,0,0,1-.38.87A1.29,1.29,0,0,1,287.79,155.76Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M293.36,150.72q0,.54,0,1.71c0,.79,0,1.36,0,1.71a1.16,1.16,0,0,1-.37.89,1.38,1.38,0,0,1-1.84,0,1.16,1.16,0,0,1-.37-.89q0-.52,0-1.71t0-1.71c0-.55,0-1.24.09-2.08s.09-1.52.09-2.08a1.16,1.16,0,0,1,.37-.89,1.38,1.38,0,0,1,1.84,0,1.16,1.16,0,0,1,.37.89c0,.56,0,1.25-.1,2.08S293.36,150.17,293.36,150.72Zm-.79-6.84a1.47,1.47,0,0,1-1-.4,1.27,1.27,0,0,1-.44-1,1.3,1.3,0,0,1,.44-1,1.52,1.52,0,0,1,1-.4,1.5,1.5,0,0,1,1,.4,1.29,1.29,0,0,1,.43,1,1.26,1.26,0,0,1-.43,1A1.45,1.45,0,0,1,292.57,143.88Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M303.15,155.76a1.15,1.15,0,0,1-1.28-1.13c-.08-.64-.17-1.28-.26-1.93a14.74,14.74,0,0,1-.14-1.93c0-.16,0-.44,0-.83s0-.67,0-.83a2.85,2.85,0,0,1,0-.33c0-.18,0-.32,0-.44,0-.51-.12-.77-.37-.77a2.09,2.09,0,0,0-1.57,1,7.74,7.74,0,0,0-1.2,2.6c0,.21,0,.49-.08.85a7.89,7.89,0,0,0-.05.84,7.89,7.89,0,0,1-.06.8,8,8,0,0,0-.06.81,1.24,1.24,0,0,1-.37.91,1.33,1.33,0,0,1-.93.35,1.24,1.24,0,0,1-.92-.35,1.19,1.19,0,0,1-.37-.9c0-.18,0-.45,0-.8a8,8,0,0,1-.06-.81c0-.6,0-1.45.13-2.53s.13-1.93.13-2.54c0-.19,0-.48,0-.85s0-.66,0-.84a1.13,1.13,0,0,1,.37-.88,1.34,1.34,0,0,1,.93-.35c.82,0,1.25.49,1.31,1.47v.1a4,4,0,0,1,2.87-1.37,2.45,2.45,0,0,1,2.44,1.47,7.49,7.49,0,0,1,.45,3v.66c0,.29,0,.49,0,.61a10.65,10.65,0,0,0,.2,1.87,11.82,11.82,0,0,1,.2,1.87,1.14,1.14,0,0,1-.38.87A1.28,1.28,0,0,1,303.15,155.76Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M314.45,149.54a32,32,0,0,0-.46,4.63,8.64,8.64,0,0,1-1,4.38q-1.23,1.81-4.33,1.82-3.63,0-3.63-1.44a1.13,1.13,0,0,1,.32-.83,1.2,1.2,0,0,1,.86-.32,6.36,6.36,0,0,1,1.21.16,7.51,7.51,0,0,0,1.39.16,2.46,2.46,0,0,0,2.05-.85,5,5,0,0,0,.75-2.64,3.38,3.38,0,0,1-1.08.73,3.42,3.42,0,0,1-1.3.24,4,4,0,0,1-3-1.21,4.27,4.27,0,0,1-1.16-3.09,5.55,5.55,0,0,1,1.55-4.11,5.8,5.8,0,0,1,4.33-1.62,4.9,4.9,0,0,1,1.52.21,2.33,2.33,0,0,1,1,.65,1.24,1.24,0,0,1,1.19,1.4A10.62,10.62,0,0,1,314.45,149.54Zm-3.62-1.87a3,3,0,0,0-2.45,1,3.65,3.65,0,0,0-.79,2.44,2.76,2.76,0,0,0,.42,1.67,1.46,1.46,0,0,0,1.26.56,2.11,2.11,0,0,0,1.54-.88,3.18,3.18,0,0,0,.83-1.66c.12-.6.26-1.53.41-2.79a2.59,2.59,0,0,0-.62-.28A1.89,1.89,0,0,0,310.83,147.67Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M319.11,156.07a1.64,1.64,0,0,1-1.08-.38,1.12,1.12,0,0,1-.46-.88,1.16,1.16,0,0,1,.46-.89,1.7,1.7,0,0,1,2.17,0,1.13,1.13,0,0,1,0,1.79A1.61,1.61,0,0,1,319.11,156.07Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150.6,
    cy: 225.01,
    r: 35.66,
    transform: "translate(-120.74 268.51) rotate(-67.5)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: "3.03 3.03"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.52,
    cy: 220.26,
    r: 35.66,
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: "3.03 3.03"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M115.51,228.76H49.44a12,12,0,0,1-12-12V83a12,12,0,0,1,12-12H71",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.7 66.47 72.33 61.48 63.7 56.49 63.7 66.47",
    fill: "#ef5182"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M280.41,98.06V83a12,12,0,0,1,12-12H351",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "343.67 66.47 352.31 61.48 343.67 56.49 343.67 66.47",
    fill: "#ef5182"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M230.65,98.06V83a12,12,0,0,0-12-12h-50.2",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.08 56.49 155.44 61.48 164.08 66.47 164.08 56.49",
    fill: "#ef5182"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M384.13,228.76h70.81a12,12,0,0,0,12-12V83a12,12,0,0,0-12-12H445",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.67 56.49 432.03 61.48 440.67 66.47 440.67 56.49",
    fill: "#ef5182"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,152.76V135.63h5.27a8,8,0,0,1,4,1,7,7,0,0,1,2.78,2.89,8.88,8.88,0,0,1,1,4.27v.78a9,9,0,0,1-1,4.25,7.05,7.05,0,0,1-2.77,2.88,8,8,0,0,1-4,1ZM18,138.49v11.43h1.7a3.85,3.85,0,0,0,3.17-1.35A6.13,6.13,0,0,0,24,144.7v-.91a6.18,6.18,0,0,0-1.09-3.95,3.8,3.8,0,0,0-3.16-1.35Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M37.31,152.76a3.74,3.74,0,0,1-.34-1.14A4.09,4.09,0,0,1,33.76,153a4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.58,3.58,0,0,1,1.5-3.1,7.41,7.41,0,0,1,4.33-1.1h1.57v-.73a2.09,2.09,0,0,0-.45-1.41,1.81,1.81,0,0,0-1.43-.53,2,2,0,0,0-1.35.41,1.39,1.39,0,0,0-.49,1.13h-3.4a3.42,3.42,0,0,1,.68-2,4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.54A5.56,5.56,0,0,1,38.86,141a4.12,4.12,0,0,1,1.38,3.32v5.52a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.37a3,3,0,0,0,1.39-.33,2.21,2.21,0,0,0,.94-.9V147H35.56c-1.7,0-2.61.59-2.72,1.77v.2a1.34,1.34,0,0,0,.45,1A1.69,1.69,0,0,0,34.5,150.39Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M46.92,136.9V140H49.1v2.49H46.92v6.36a1.53,1.53,0,0,0,.27,1,1.39,1.39,0,0,0,1,.3,5,5,0,0,0,1-.08v2.58a7.13,7.13,0,0,1-2.06.3q-3.57,0-3.65-3.61v-6.86H41.66V140h1.86V136.9Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M58.37,152.76a3.74,3.74,0,0,1-.34-1.14A4.09,4.09,0,0,1,54.82,153a4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.58,3.58,0,0,1,1.5-3.1,7.41,7.41,0,0,1,4.33-1.1h1.57v-.73a2.09,2.09,0,0,0-.45-1.41,1.81,1.81,0,0,0-1.43-.53,2,2,0,0,0-1.35.41,1.39,1.39,0,0,0-.49,1.13h-3.4a3.42,3.42,0,0,1,.68-2,4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.54A5.56,5.56,0,0,1,59.92,141a4.12,4.12,0,0,1,1.38,3.32v5.52a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.37a3,3,0,0,0,1.39-.33,2.21,2.21,0,0,0,.94-.9V147H56.62c-1.7,0-2.61.59-2.72,1.77v.2a1.34,1.34,0,0,0,.45,1A1.69,1.69,0,0,0,55.56,150.39Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 429.21,
    y: 118.18,
    width: 64.77,
    height: 34.93,
    fill: "#ef5182"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M443.71,152.76V135.63H449a8,8,0,0,1,4,1,7,7,0,0,1,2.78,2.89,8.88,8.88,0,0,1,1,4.27v.78a9,9,0,0,1-1,4.25,7.05,7.05,0,0,1-2.77,2.88,8,8,0,0,1-4,1Zm3.53-14.27v11.43h1.7a3.85,3.85,0,0,0,3.17-1.35,6.07,6.07,0,0,0,1.11-3.87v-.91a6.18,6.18,0,0,0-1.08-3.95,3.8,3.8,0,0,0-3.16-1.35Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52,152.76a3.74,3.74,0,0,1-.34-1.14A4.1,4.1,0,0,1,463,153a4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.58,3.58,0,0,1,1.5-3.1,7.41,7.41,0,0,1,4.33-1.1H466v-.73a2,2,0,0,0-.46-1.41,1.78,1.78,0,0,0-1.43-.53,2,2,0,0,0-1.34.41,1.39,1.39,0,0,0-.49,1.13h-3.4a3.42,3.42,0,0,1,.68-2,4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.54,5.56,5.56,0,0,1,3.74,1.19,4.12,4.12,0,0,1,1.38,3.32v5.52a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.37a3,3,0,0,0,1.39-.33,2.21,2.21,0,0,0,.94-.9V147h-1.27c-1.7,0-2.61.59-2.72,1.77v.2a1.37,1.37,0,0,0,.44,1A1.73,1.73,0,0,0,463.71,150.39Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M476.13,136.9V140h2.18v2.49h-2.18v6.36a1.53,1.53,0,0,0,.27,1,1.39,1.39,0,0,0,1,.3,5,5,0,0,0,1-.08v2.58a7.13,7.13,0,0,1-2.06.3c-2.39,0-3.6-1.2-3.65-3.61v-6.86h-1.86V140h1.86V136.9Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M487.58,152.76a3.74,3.74,0,0,1-.34-1.14A4.09,4.09,0,0,1,484,153a4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.58,3.58,0,0,1,1.5-3.1,7.41,7.41,0,0,1,4.33-1.1h1.57v-.73a2.09,2.09,0,0,0-.45-1.41,1.81,1.81,0,0,0-1.43-.53,2,2,0,0,0-1.35.41,1.39,1.39,0,0,0-.49,1.13H480a3.42,3.42,0,0,1,.68-2,4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.54,5.56,5.56,0,0,1,3.74,1.19,4.12,4.12,0,0,1,1.38,3.32v5.52a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.37a3,3,0,0,0,1.39-.33,2.21,2.21,0,0,0,.94-.9V147h-1.27c-1.7,0-2.61.59-2.72,1.77v.2a1.37,1.37,0,0,0,.44,1A1.73,1.73,0,0,0,484.77,150.39Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.98,
    y: 83.75,
    width: 83.17,
    height: 37.93,
    fill: "#ef5182"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M296.47,94.78v34.94H216.3V94.78h80.17m3-3H213.3v40.94h86.17V91.78Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5,117H239v2.83H228V102.69h3.53Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M248.18,119.82a3.57,3.57,0,0,1-.35-1.14,4.1,4.1,0,0,1-3.21,1.38,4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.6,3.6,0,0,1,1.5-3.11,7.45,7.45,0,0,1,4.34-1.09h1.56v-.73a2.09,2.09,0,0,0-.45-1.41,1.76,1.76,0,0,0-1.43-.53,2,2,0,0,0-1.35.41,1.4,1.4,0,0,0-.48,1.13h-3.41a3.4,3.4,0,0,1,.69-2,4.5,4.5,0,0,1,1.93-1.48,7.13,7.13,0,0,1,2.8-.53,5.53,5.53,0,0,1,3.73,1.18,4.16,4.16,0,0,1,1.39,3.33v5.51a5.94,5.94,0,0,0,.5,2.74v.2Zm-2.82-2.36a2.86,2.86,0,0,0,1.39-.34,2.11,2.11,0,0,0,.94-.9V114h-1.27c-1.7,0-2.61.58-2.72,1.76v.2a1.38,1.38,0,0,0,.45,1A1.76,1.76,0,0,0,245.36,117.46Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M265.19,113.58a7.71,7.71,0,0,1-1.31,4.77,4.32,4.32,0,0,1-3.65,1.71,4,4,0,0,1-3.3-1.59l-.15,1.35h-3.06V101.75h3.4v6.49a3.85,3.85,0,0,1,3.09-1.38,4.36,4.36,0,0,1,3.65,1.71,7.68,7.68,0,0,1,1.33,4.82Zm-3.4-.25a5.13,5.13,0,0,0-.61-2.82,2.09,2.09,0,0,0-1.83-.89,2.25,2.25,0,0,0-2.23,1.33v5a2.27,2.27,0,0,0,2.26,1.34,2.1,2.1,0,0,0,2.16-1.62A8.21,8.21,0,0,0,261.79,113.33Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M273.14,120.06a6.26,6.26,0,0,1-4.56-1.72,6.1,6.1,0,0,1-1.76-4.57v-.33a7.59,7.59,0,0,1,.75-3.43,5.35,5.35,0,0,1,2.1-2.33,5.84,5.84,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.11,1.65,6.67,6.67,0,0,1,1.5,4.67v1.39h-8.11a3.15,3.15,0,0,0,1,2,3,3,0,0,0,2.1.75,3.69,3.69,0,0,0,3.07-1.42l1.67,1.87a5.07,5.07,0,0,1-2.07,1.68A6.73,6.73,0,0,1,273.14,120.06Zm-.39-10.46a2.12,2.12,0,0,0-1.64.69,3.47,3.47,0,0,0-.8,2H275V112a2.52,2.52,0,0,0-.62-1.76A2.19,2.19,0,0,0,272.75,109.6Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M283.9,119.82h-3.42V101.75h3.42Z",
    transform: "translate(-5.83 -9.54)",
    fill: "#fff"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M105,92.78l-.64-4.17m9.43.89L107.85,94m15.33-5.59-4-.38m13.17-4-3.77,2.86M144,79.48l-6.38,1.83m12.43-11L148,75.83M145.2,58.5l4.26,6.43m-14.81-16.2,6.55,5.35M116.39,44.8l12.94,1.65M98.1,52.53l12.64-6.7M88.55,65.46l5.34-8.94M90.77,78.11l-2.71-7.25m13.5,12.85-2-1.69-4.73-.67",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M98.29,67,96.08,56.88M93.46,78.41,97.3,72.5",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M108.66,60.93l-7.52,7M98.31,54.86,108,58",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M115.58,46.5l6.25,6m-10.44,3.45,1.49-8.52m8.27,8.1-7.42,2.45",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M133.37,49.65l2.52,11.59m-9.56-8.62,4.15-3.41m3.67,13.14-7.76-6",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M138.49,61.89l3.08-3.61m6.61,8.5-8.7-1.94",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M135,66.77l-3.79,6.39m13.94,3-6.86-9.57m-5.65,9.62,11.29,1.9",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M128.88,78.66,127,85.74m5.9-6-1.32-1.67",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M119.88,68.54l-5.61,5.27m13.49-.39L124,68.8m-5.56,16.89,9-7.94m-14.36,1,2.12,6.12",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M109.32,74.64l-7.63-3.44m4.12,12.13,4.33-5.15",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M122.56,63.5l1-6m-10.16,3.06,6.22,4.21",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M382.19,91.78l-.64-4.17m9.42.89L385.06,93m15.32-5.59-4-.38m13.16-4-3.76,2.86m15.44-7.35-6.39,1.83m12.43-11-2.09,5.57M422.4,57.5l4.27,6.43m-14.81-16.2,6.55,5.35M393.59,43.8l13,1.65m-31.23,6.08,12.63-6.7M365.76,64.46l5.34-8.94M368,77.11l-2.72-7.25m13.51,12.85-2-1.69L372,80.35",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M375.5,66l-2.21-10.14m-2.62,21.53,3.84-5.91",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M385.87,59.93l-7.52,7m-2.84-13.06,9.7,3.1",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M392.78,45.5l6.26,6M388.6,54.91l1.49-8.52m8.26,8.1-7.41,2.45",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M410.58,48.65l2.52,11.59m-9.56-8.62,4.15-3.41m3.67,13.14-7.76-6",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M415.7,60.89l3.08-3.61m6.61,8.5-8.7-1.94",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M412.21,65.77l-3.79,6.39m13.94,3-6.86-9.57m-5.65,9.62,11.29,1.9",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M406.09,77.66l-1.92,7.08m5.89-6-1.31-1.67",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M397.09,67.54l-5.62,5.27m13.5-.39-3.78-4.62m-5.55,16.89,9-7.94m-14.35,1,2.12,6.12",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M386.53,73.64l-7.64-3.44M383,82.33l4.33-5.15",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M399.76,62.5l1-6m-10.16,3.06,6.22,4.21",
    transform: "translate(-5.83 -9.54)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.23,
    strokeDasharray: "26.73 4.46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFigureMotiv2);
export default __webpack_public_path__ + "static/media/web-figure-motiv-2.126333ca25990e3b166802e0a360ddca.svg";
export { ForwardRef as ReactComponent };